import React, { useState, useEffect, useCallback, useRef } from "react";
import { connect } from "react-redux";
import { css, StyleSheet } from "aphrodite/no-important";
import { useHistory } from "react-router-dom";
import debounce from "lodash.debounce";
import { clone } from "ramda";
import {
  TextInput,
  PopupMenu,
  Drawer,
  Checkbox,
  TimePicker,
  DatePicker,
  Button,
  Loader,
  Toast,
  TextInputWithLabel,
  DialogBox
} from "quantux-ui";
import CaseCard from "./case-card";
import { gray, blue, salmon, yellow, cyan, magenta } from "../../theme";
import WarningDialog from "../warning-dialog";
import TimeScaleHeader from "./time-scale-header";
import ScheduleCaseDrawer2 from "../case-schedule/schedule-case-drawer";
import {
  BASE_URL,
  getShortWeekDay,
  padZero,
  titleCase,
  ascendingSortCaseSchedulesByStart,
  debugLogToConsole,
  makeIsoDateString,
  parseDateStringFromIsoDate,
  parseDateFromIsoString,
  calculateCaseBlockTimeInMinutes,
  ORIGIN,
  getHighlightedText
} from "../../utils";
import {
  initiateNewCaseBlock,
  initiateNewCaseSchedule,
  updateCaseBlockData,
  saveCaseBlock,
  loadCaseBlocksData,
  addDirectorBlock,
  getProvidersSchedule,
  resetCaseBlocksState,
  getCaseSchedulesData,
  setCaseBlockCaseInitialData,
  editCaseBlockCaseMarkedForCreation,
  toggleScheduleCaseDrawer,
  toggleCaseBlockDrawer,
  createNewCaseBlock,
  editCaseBlock,
  setEditCaseBlockCases,
  setCaseBlockActiveCaseSchedule,
  toggleCbCaseScheduleDashboard,
  markCaseBlockCaseForDeletion,
  unMarkCaseBlockCaseForDeletion,
  unMarkCaseBlockCaseForCreation,
  resetCaseBlockLinkTimeFlag,
  toggleCbLoader,
  setSelectedCaseBlockDate,
  saveFacilityColors
} from "../../actions";
import GanttRow from "./gantt-row";
import CbScheduleDashboard from "./cb-schedule-dashboard";
import LeftPinnedEllipsis from "./left-pinned-ellipsis";

let prvScrollLeft = 0;
let prvScrollTop = 0;
const ROW_HEIGHT = 100;
const AUTO_SCROLL_HOUR = 7;
const TODAY = new Date();
const DIALOG_WIDTH = window.innerWidth <= 576 ? (window.innerWidth - 16) : 350;

const GanttGrid = (props) => {
  const [hourWidth, setHourWidth] = useState(210);
  const [facilitySearch, setFacilitySearch] = useState("");
  const [startHour, _] = useState(0);
  const [endHour, __] = useState(23);
  const [autoScrollHour, ___] = useState(AUTO_SCROLL_HOUR);
  const [showGridToolbarMenu, setShowGridToolbarMenu] = useState(false);
  const [activeLocation, setActiveLocation] = useState({});
  // Drawer Menus
  const [showSurgMenu, setShowSurgMenu] = useState(false);
  const [showAnesMenu, setShowAnesMenu] = useState(false);
  const [showCrnaMenu, setShowCrnaMenu] = useState(false);
  const [showLocationMenu, setShowLocationMenu] = useState(false);
  // --- Case Block Items
  const [locations, setLocations] = useState([]);
  // --- Case Block Items New
  const [surgeons, setSurgeons] = useState([]);
  const [surgeonSearch, setSurgeonSearch] = useState("");
  const [isSurgeonSearchPristine, setIsSurgeonSearchPristine] = useState(true);
  const [anesthesiologists, setAnesthesiologists] = useState([]);
  const [anesthesiologistSearch, setAnesthesiologistSearch] = useState("");
  const [isAnesthesiologistSearchPristine, setIsAnesthesiologistSearchPristine] = useState(true);
  const [crnas, setCrnas] = useState([]);
  const [crnaSearch, setCrnaSearch] = useState("");
  const [isCrnaSearchPristine, setIsCrnaSearchPristine] = useState(true);
  const [caseBlockId, setCaseBlockId] = useState(null);
  const [blockCases, setBlockCases] = useState([]);
  const [patientData, setPatientData] = useState({});
  // --- Case Data
  const [initialCaseData, setInitialCaseData] = useState({});
  // Schedule day date
  const [scheduleDate, setScheduleDate] = useState(TODAY.getDate());
  const [scheduleMonth, setScheduleMonth] = useState(TODAY.getMonth());
  const [scheduleYear, setScheduleYear] = useState(TODAY.getFullYear());
  // -- Provider availability drawer
  const [showProviderAvailabilityDrawer, setShowProviderAvailabilityDrawer] = useState(false);
  const [showAvailMenu, setShowAvailMenu] = useState(false);
  const [showProviderMenu, setShowProviderMenu] = useState(false);
  const [selectedAvailStatus, setSelectedAvailStatus] = useState("available");
  const [selectedProviderType, setSelectedProviderType] = useState("physicians");
  const [providerSearch, setProviderSearch] = useState("");
  // Assignments | Director Block Drawer
  const [activeAssignment, setActiveAssignment] = useState({});
  const [showDirectorBlockDrawer, setShowDirectorBlockDrawer] = useState(false);
  const [showCaseBlockDrawerCloseWarning, setShowCaseBlockDrawerCloseWarning] = useState(false);
  const [isCaseBlockDrawerCloseWarningVisible, setIsCaseBlockDrawerCloseWarningVisible] = useState(false);
  const [showShiftBlockDrawer, setShowShiftBlockDrawer] = useState(false);
  const [showCallBlockDrawer, setShowCallBlockDrawer] = useState(false);
  const [selectedDirector, setSelectedDirector] = useState({});
  const [selectedShiftProvider, setSelectedShiftProvider] = useState({});
  const [selectedCallProvider, setSelectedCallProvider] = useState({});
  const [directors, setDirectors] = useState([]);
  const [directorSearch, setDirectorSearch] = useState("");
  const [isDirectorSearchPristine, setIsDirectorSearchPristine] = useState(true);
  const [showDirMenu, setShowDirMenu] = useState(false);
  // -- Shift blocks
  const [shiftProviders, setShiftProviders] = useState([]);
  const [shiftSearch, setShiftSearch] = useState("");
  const [isShiftSearchPristine, setIsShiftSearchPristine] = useState(true);
  const [showShiftMenu, setShowShiftMenu] = useState(false);
  // -- Call blocks
  const [callProviders, setCallProviders] = useState([]);
  const [callSearch, setCallSearch] = useState("");
  const [isCallSearchPristine, setIsCallSearchPristine] = useState(true);
  const [showCallMenu, setShowCallMenu] = useState(false);
  // Director Times
  const [dirBlockStartDate, setDirBlockStartDate] = useState(TODAY.getDate());
  const [dirBlockStartMonth, setDirBlockStartMonth] = useState(TODAY.getMonth(),);
  const [dirBlockStartYear, setDirBlockStartYear] = useState(TODAY.getFullYear(),);
  const [isDirBlockStartDatePristine, setIsDirBlockStartDatePristine] = useState(true);
  const [dirBlockStopDate, setDirBlockStopDate] = useState(TODAY.getDate());
  const [dirBlockStopMonth, setDirBlockStopMonth] = useState(TODAY.getMonth());
  const [dirBlockStopYear, setDirBlockStopYear] = useState(TODAY.getFullYear());
  const [isDirBlockStopDatePristine, setIsDirBlockStopDatePristine] = useState(true);
  const [dirBlockStartHour, setDirBlockStartHour] = useState(TODAY.getHours());
  const [dirBlockStartMinute, setDirBlockStartMinute] = useState(TODAY.getMinutes(),);
  const [isDirBlockStartTimePristine, setIsDirBlockStartTimePristine] = useState(true);
  const [dirBlockStopHour, setDirBlockStopHour] = useState(TODAY.getHours());
  const [dirBlockStopMinute, setDirBlockStopMinute] = useState(TODAY.getMinutes(),);
  const [isDirBlockStopTimePristine, setIsDirBlockStopTimePristine] = useState(true);
  // Shift Times
  const [shiftBlockStartDate, setShiftBlockStartDate] = useState(TODAY.getDate(),);
  const [shiftBlockStartMonth, setShiftBlockStartMonth] = useState(TODAY.getMonth(),);
  const [shiftBlockStartYear, setShiftBlockStartYear] = useState(TODAY.getFullYear(),);
  const [isShiftBlockStartDatePristine, setIsShiftBlockStartDatePristine] = useState(false);
  const [shiftBlockStopDate, setShiftBlockStopDate] = useState(TODAY.getDate());
  const [shiftBlockStopMonth, setShiftBlockStopMonth] = useState(TODAY.getMonth());
  const [shiftBlockStopYear, setShiftBlockStopYear] = useState(TODAY.getFullYear());
  const [isShiftBlockStopDatePristine, setIsShiftBlockStopDatePristine] = useState(false);
  const [shiftBlockStartHour, setShiftBlockStartHour] = useState(TODAY.getHours());
  const [shiftBlockStartMinute, setShiftBlockStartMinute] = useState(TODAY.getMinutes());
  const [isShiftBlockStartTimePristine, setIsShiftBlockStartTimePristine] = useState(true);
  const [shiftBlockStopHour, setShiftBlockStopHour] = useState(TODAY.getHours());
  const [shiftBlockStopMinute, setShiftBlockStopMinute] = useState(TODAY.getMinutes());
  const [isShiftBlockStopTimePristine, setIsShiftBlockStopTimePristine] = useState(true);
  // Call Times
  const [callBlockStartDate, setCallBlockStartDate] = useState(TODAY.getDate());
  const [callBlockStartMonth, setCallBlockStartMonth] = useState(TODAY.getMonth());
  const [callBlockStartYear, setCallBlockStartYear] = useState(TODAY.getFullYear());
  const [isCallBlockStartDatePristine, setIsCallBlockStartDatePristine] = useState(true);
  const [callBlockStopDate, setCallBlockStopDate] = useState(TODAY.getDate());
  const [callBlockStopMonth, setCallBlockStopMonth] = useState(TODAY.getMonth());
  const [callBlockStopYear, setCallBlockStopYear] = useState(TODAY.getFullYear());
  const [isCallBlockStopDatePristine, setIsCallBlockStopDatePristine] = useState(true);
  const [callBlockStartHour, setCallBlockStartHour] = useState(TODAY.getHours());
  const [callBlockStartMinute, setCallBlockStartMinute] = useState(TODAY.getMinutes());
  const [isCallBlockStartTimePristine, setIsCallBlockStartTimePristine] = useState(true);
  const [callBlockStopHour, setCallBlockStopHour] = useState(TODAY.getHours());
  const [callBlockStopMinute, setCallBlockStopMinute] = useState(TODAY.getMinutes());
  const [isCallBlockStopTimePristine, setIsCallBlockStopTimePristine] = useState(true);
  // ---
  const [showDirBlockRepeatMenu, setShowDirBlockRepeatMenu] = useState(false);
  const [dirBlockRepeatFrequency, setDirBlockRepeatFrequency] = useState("none");
  const [showShiftBlockRepeatMenu, setShowShiftBlockRepeatMenu] = useState(false);
  const [shiftBlockRepeatFrequency, setShiftBlockRepeatFrequency] = useState("none");
  const [showCallBlockRepeatMenu, setShowCallBlockRepeatMenu] = useState(false);
  const [callBlockRepeatFrequency, setCallBlockRepeatFrequency] = useState("none");
  // -- Cases marked for creation
  const [casesToCreate, setCasesToCreate] = useState([]);
  // --
  const [showToastMessage, setShowToastMessage] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [rowHeights, setRowHeights] = useState([]); // -- Row heights
  const [practiceUsers, setPracticeUsers] = useState([]);
  // --
  const [showBlockTimeError, setShowBlockTimeError] = useState(false);
  // --
  const [isBlkStartTimePristine, setIsBlkStartTimePristine] = useState(true);
  const [isBlkEndTimePristine, setIsBlkEndTimePristine] = useState(true);
  const [blkStartDate, setBlkStartDate] = useState(TODAY.getDate());
  const [blkStartMonth, setBlkStartMonth] = useState(TODAY.getMonth());
  const [blkStartYear, setBlkStartYear] = useState(TODAY.getFullYear());
  const [blkEndDate, setBlkEndDate] = useState(TODAY.getDate());
  const [blkEndMonth, setBlkEndMonth] = useState(TODAY.getMonth());
  const [blkEndYear, setBlkEndYear] = useState(TODAY.getFullYear());
  const [canCreateCaseBlock, setCanCreateCaseBlock] = useState(false);
  // -- GantRow is not updating after adding new case block, thats why I have to use this state var
  const [caseBlocks, setCaseBlocks] = useState([]);
  // --
  const [showBgColorPicker, setShowBgColorPicker] = useState(false);
  const [showFgColorPicker, setShowFgColorPicker] = useState(false);
  const [bgColor, setBgColor] = useState(cyan[500]);
  const [fgColor, setFgColor] = useState(magenta[500]);
  const [selectedFacilityId, setSelectedFacilityId] = useState('');

  // ___ Props ________________________________________________________________
  const {
    selectedPractice,
    practiceFacilities: facilities,
    practiceFacilitiesLocations: facilityLocations,
    practiceDirectorBlocks: dirBlocks,
    practiceShiftBlocks: shiftBlocks,
    practiceCallBlocks: callBlocks,
    practiceCaseBlocks,
    activeCaseBlock = {}
  } = props;

  // Active case block props
  const {
    surgeon = {},
    anesthesiologist = {},
    isNoneAnesthesiologist = false,
    crna = {},
    isNoneCrna = false,
    isLinked = false,
    blockStartHour = 0,
    blockStartMinute = 0,
    blockEndHour = 0,
    blockEndMinute = 0,
    blockStartDate = TODAY.toISOString(),
    isBlockStartDatePristine = false,
    isBlockEndDatePristine = false,
    isBlockStartTimePristine = true,
    isBlockEndTimePristine = true,
    blockEndDate = TODAY.toISOString(),
    linkedEndDate = new Date().toISOString(),
    linkedEndHour = 0,
    linkedEndMinute = 0,
    linkedStartDate = new Date().toISOString(),
    linkedStartHour = 0,
    linkedStartMinute = 0
  } = activeCaseBlock;

  const caseBlockSelectedSurgeon = surgeon;
  const caseBlockSelectedAnesthesiologist = anesthesiologist;
  const caseBlockSelectedCrna = crna;

  useEffect(() => {
    if (caseBlocks.length !== practiceCaseBlocks.length) {
      setCaseBlocks(practiceCaseBlocks);
      scrollToStartHour();
    }
  }, [practiceCaseBlocks]);

  useEffect(() => {
    const { year, month, date } = parseDateFromIsoString(blockStartDate);
    setBlkStartDate(date);
    setBlkStartMonth(month);
    setBlkStartYear(year);
  }, [blockStartDate]);

  useEffect(() => {
    const { year, month, date } = parseDateFromIsoString(blockEndDate);
    setBlkEndDate(date);
    setBlkEndMonth(month);
    setBlkEndYear(year);
  }, [blockEndDate]);

  useEffect(() => {
    if (isLinked) {
      setCanCreateCaseBlock(true);
    } else {
      setCanCreateCaseBlock(!isBlkStartTimePristine && !isBlkEndTimePristine);
    }
  }, [
    isLinked,
    isBlkStartTimePristine,
    isBlkEndTimePristine
  ]);

  useEffect(() => {
    if (props.shouldReCalculateBlockTime && isLinked) {
      linkCaseBlockTimes();
      props.resetCaseBlockLinkTimeFlag();
    }
  }, [props.shouldReCalculateBlockTime]);

  useEffect(() => {
    debugLogToConsole('🚀🚀🚀 isBlockStartTimePristine, isBlockEndTimePristine Effect');
    setIsBlkStartTimePristine(isBlockStartTimePristine);
    setIsBlkEndTimePristine(isBlockEndTimePristine);
  }, [
    isBlockStartTimePristine,
    isBlockEndTimePristine
  ]);

  useEffect(() => {
    setScheduleDate(props.selectedCaseBlockDate);
    setScheduleMonth(props.selectedCaseBlockMonth);
    setScheduleYear(props.selectedCaseBlockYear);
  }, [
    props.selectedCaseBlockDate,
    props.selectedCaseBlockMonth,
    props.selectedCaseBlockYear
  ]);

  // ____ REFS ________________________________________________________________
  const tsHeader = useRef();
  const leftRowsRef = useRef();
  const gridToolbarMenuRef = useRef();
  const scroller = useRef();
  const surgMenuRef = useRef();
  const dirMenuRef = useRef();
  const shiftMenuRef = useRef();
  const callMenuRef = useRef();
  const locationRef = useRef();
  const anesMenuRef = useRef();
  const crnaMenuRef = useRef();
  const availMenuRef = useRef();
  const providerMenuRef = useRef();
  const dirBlockRepeatMenuRef = useRef();
  const shiftBlockRepeatMenuRef = useRef();
  const callBlockRepeatMenuRef = useRef();
  const loadDataRef = useRef(true);

  // ___ React Router _________________________________________________________
  const history = useHistory();

  /* --- Surgeon Search --- */
  const searchSurgeons = (value) => {
    const url = new URL(`${BASE_URL}/users/searchMedProsSurgeons`);
    const params = { searchTerm: value.trim() };
    url.search = new URLSearchParams(params).toString();
    fetch(url)
      .then((res) => res.text())
      .then((result) => {
        const data = JSON.parse(result);
        setSurgeons(data.users);
      })
      .catch((error) => console.log("error", error));
  };
  const debouncedSurgeonsSearch = useCallback(
    debounce((value) => searchSurgeons(value), 800),
    [],
  );

  /* --- Anesthesiologist Search --- */
  const searchAnesthesiologists = (value) => {
    const url = new URL(`${BASE_URL}/users/searchMedProsAnesthesiologists`);
    const params = { searchTerm: value.trim() };
    url.search = new URLSearchParams(params).toString();
    fetch(url)
      .then((res) => res.text())
      .then((result) => {
        const data = JSON.parse(result);
        setAnesthesiologists(data.users);
      })
      .catch((error) => console.log("error", error));
  };
  const debouncedAnesthesiologistsSearch = useCallback(
    debounce((value) => searchAnesthesiologists(value), 800),
    [],
  );

  /* --- Director Search --- */
  const searchDirectors = (value) => {
    const url = new URL(`${BASE_URL}/users/searchMedProsAnesthesiologists`);
    const params = { searchTerm: value.trim() };
    url.search = new URLSearchParams(params).toString();
    fetch(url)
      .then((res) => res.text())
      .then((result) => {
        const data = JSON.parse(result);
        setDirectors(data.users);
      })
      .catch((error) => console.log("error", error));
  };
  const debouncedDirectorsSearch = useCallback(
    debounce((value) => searchDirectors(value), 800),
    [],
  );

  /* --- Shift Search --- */
  const searchShiftProviders = (value) => {
    const url = new URL(`${BASE_URL}/users/searchMedProsAnesthesiologists`);
    const params = { searchTerm: value.trim() };
    url.search = new URLSearchParams(params).toString();
    fetch(url)
      .then((res) => res.text())
      .then((result) => {
        const data = JSON.parse(result);
        setShiftProviders(data.users);
      })
      .catch((error) => console.log("error", error));
  };
  const debouncedShiftProvidersSearch = useCallback(
    debounce((value) => searchShiftProviders(value), 800),
    [],
  );

  /* --- Call Provider Search --- */
  const searchCallProviders = (value) => {
    const url = new URL(`${BASE_URL}/users/searchMedProsAnesthesiologists`);
    const params = { searchTerm: value.trim() };
    url.search = new URLSearchParams(params).toString();
    fetch(url)
      .then((res) => res.text())
      .then((result) => {
        const data = JSON.parse(result);
        setCallProviders(data.users);
      })
      .catch((error) => console.log("error", error));
  };
  const debouncedCallProvidersSearch = useCallback(
    debounce((value) => searchCallProviders(value), 800),
    [],
  );

  // --- CRNA/Practice Search ---
  const searchCrnas = (value) => {
    const url = new URL(`${BASE_URL}/users/searchMedProsCrnas`);
    const params = { searchTerm: value.trim() };
    url.search = new URLSearchParams(params).toString();
    fetch(url)
      .then((res) => res.text())
      .then((result) => {
        const data = JSON.parse(result);
        setCrnas(data.users);
      })
      .catch((error) => console.log("error", error));
  };
  const debouncedCrnasSearch = useCallback(
    debounce((value) => searchCrnas(value), 800),
    [],
  );

  // ____ STYLES ______________________________________________________________
  const styles = StyleSheet.create({
    providerAvailDrawer: {
      width: "360px",
      minWidth: "360px",
    },
    providerAvailDrawerContent: {
      height: "calc(100% - 65px)",
      maxHeight: "calc(100% - 65px)",
      overflowY: "auto",
      background: gray[600]
    },
    gridParentContainer: {
      width: showProviderAvailabilityDrawer ? "calc(100% - 360px)" : "100%",
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      height: "40px",
      borderBottom: `1px solid ${gray[800]}`,
      padding: "0 8px",
      background: gray[600],
      width: "100%",
    },
    cbLoader: {
      position: 'absolute',
      height: "calc(100% - 48px)",
      width: "100%",
      opacity: '0.75',
      background: 'black',
      zIndex: '1'
    },
    gridContainer: {
      position: 'relative',
      height: "calc(100% - 40px)",
      width: "100%",
      background: gray[600],
    },
    gridToolbarIcon: {
      height: "50px",
      width: "40px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      ":hover": {
        color: blue[500],
      },
    },
    gridEllipsisMenuParent: {
      position: "fixed",
      height: "64px",
      width: "140px",
      background: "black",
      zIndex: "100",
    },
    gridEllipsisMenuContainer: {
      background: "#103A60",
      width: "220px",
      maxWidth: "220px",
      minHeight: "80px",
      fontSize: "14px",
    },
    gridEllipsisMenuItem: {
      display: "flex",
      alignItems: "center",
      height: "32px",
      width: "100%",
      paddingLeft: "8px",
      background: "#103A60",
      color: blue[400],
      ":not(.active):hover": {
        background: "#0066CC",
        color: "white",
      },
    },
    gridEllipsisMenuItemActive: {
      background: gray[700],
      color: "white",
    },
    header: {
      display: "flex",
    },
    leftHeader: {
      width: "172px",
      minWidth: "172px",
      background: gray[600],
      height: "48px",
      borderBottom: `1px solid ${gray[800]}`,
      borderRight: `2px solid ${blue[600]}`,
      paddingLeft: "8px",
    },
    leftHeaderTitle: {
      fontSize: "12px",
      fontWeight: "bold",
    },
    centerHeader: {
      width: "calc(100% - 172px)",
      maxWidth: "calc(100% - 172px)",
      overflow: "hidden",
      height: "48px",
      background: gray[600],
      borderBottom: `1px solid ${gray[800]}`,
    },
    rows: {
      display: "flex",
      height: "calc(100% - 48px)",
    },
    leftRows: {
      width: "172px",
      height: "100%",
      background: gray[600],
      borderRight: `2px solid ${blue[600]}`
    },
    centerRows: {
      width: "calc(100% - 172px)",
      height: "100%",
      overflow: "auto",
      background: gray[600],
    },
    sideDrawerContainer: {
      background: "#002448",
      color: gray[300],
      height: "100%",
      position: "relative",
      display: "flex",
      flexFlow: "column",
    },
    sideDrawerHeader: {
      display: "flex",
      flexFlow: "column",
      alignItems: "center",
      justifyContent: "space-between",
      fontWeight: "bold",
      borderBottom: "1px solid black",
      flexShrink: "0",
      fontSize: "14px",
      background: blue[700],
    },
    sideDrawerHeaderTopRow: {
      height: "24px",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginTop: "4px",
      flexShrink: "0",
      padding: "0 8px",
    },
    sideDrawerHeaderRow: {
      display: "flex",
      // paddingLeft: '8px',
      padding: "0 8px",
      marginTop: "4px",
      width: "100%",
      // height: '24px'
    },
    sideDrawerHeaderRowTitle: {
      minWidth: "50px",
      textAlign: "right",
      marginRight: "8px",
    },
    sideDrawerHeaderCloseIcon: {
      color: gray[300],
      ":hover": {
        color: salmon[500],
      },
    },
    sideDrawerContentArea: {
      overflowY: "auto",
      color: gray[300],
      flexGrow: "1",
      padding: "8px",
    },
    sideDrawerFooter: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      background: gray[700],
      height: "48px",
      width: "100%",
      borderTop: `1px solid ${gray[500]}`,
      flexShrink: "0",
      padding: "0 8px",
    },
    facilityLocationCell: {
      display: "flex",
      fontSize: "14px",
      fontWeight: "bold",
      padding: "8px",
      borderBottom: `1px solid ${gray[600]}`,
      background: blue[900]
    },
    facilityLocationCellLeft: {
      width: "122px",
      maxWidth: "122px",
    },
    facilityLocationRow: {
      height: `${ROW_HEIGHT}px`,
      borderBottom: `1px solid ${gray[800]}`,
      width: `${(endHour - startHour + 1) * hourWidth + 8}px`,
      background: "yellow",
    },
    cpTtitle: {
      minWidth: '150px'
    }
  });

  const scrollToStartHour = () => {
    if (scroller.current && autoScrollHour - startHour >= 1) {
      const scrollValue = (autoScrollHour - startHour) * hourWidth;
      // scroller.current.scrollLeft = scrollValue;
      setTimeout(() => {
        scroller.current.scroll(+scrollValue, 0);
      }, 1000);
      if (tsHeader.current) {
        tsHeader.current.style.transform = `translateX(${-1 * scrollValue}px)`;
      }
    }
  };

  // ____ Helper Function _____________________________________________________
  const markConcurrentCases = (bCases) => {
    let lcStartHour = -1;
    let lcStartMinute = -1;
    let lcEndHour = -1;
    let lcEndMinute = -1;
    let lastIndex = -1;

    return (bCase, idx) => {
      const startHour =
        bCase.scheduleStartHour !== undefined
          ? bCase.scheduleStartHour
          : bCase.scheduleTimeStartHour;
      const startMin =
        bCase.scheduleStartMin !== undefined
          ? bCase.scheduleStartMin
          : bCase.scheduleTimeStartMinute;

      const endHour =
        bCase.scheduleEndHour !== undefined
          ? bCase.scheduleEndHour
          : bCase.scheduleTimeEndHour;
      const endMin =
        bCase.scheduleEndMin !== undefined
          ? bCase.scheduleEndMin
          : bCase.scheduleTimeEndMinute;

      // Case scheduels with null/undefined times
      if (
        startHour === undefined ||
        startMin === undefined ||
        endHour === undefined ||
        endMin === undefined
      ) {
        bCase.isConcurrent = false;
        return;
      }

      // First element
      if (
        lcStartHour === -1 &&
        lcStartMinute === -1 &&
        lcEndHour === -1 &&
        lcEndMinute === -1
      ) {
        lcStartHour = startHour;
        lcStartMinute = startMin;
        lcEndHour = endHour;
        lcEndMinute = endMin;
        lastIndex = idx;
        return;
      }
      // Rest of the block cases
      if (startHour > lcEndHour) {
        bCase.isConcurrent = false;
      } else if (startHour === lcEndHour) {
        if (startMin >= lcEndMinute) {
          bCase.isConcurrent = false;
        } else {
          bCase.isConcurrent = true;
          bCases[lastIndex].isConcurrent = true;
        }
      } else {
        bCase.isConcurrent = true;
        bCases[lastIndex].isConcurrent = true;
      }

      lcStartHour = startHour;
      lcStartMinute = startMin;
      lcEndHour = endHour;
      lcEndMinute = endMin;
      lastIndex = idx;
    };
  };

  const markConcurrentCasesHandler = (bCases) => {
    const updatedBlockCases = clone(bCases);
    const cf = markConcurrentCases(updatedBlockCases);
    updatedBlockCases.forEach((bc, idx) => {
      cf(bc, idx);
    });

    return updatedBlockCases;
  };

  /* ____ EFFECTS __________________________________________________________ */
  useEffect(() => {
    if (Object.keys(props.selectedPractice).length === 0) {
      props.toggleCbLoader(true);
      props.getCaseSchedulesData(null, props.scheduleDate, props.scheduleMonth, props.scheduleYear, props.scheduleEndDate, props.scheduleEndMonth, props.scheduleEndYear);
      scrollToStartHour();
    }
  }, []);

  useEffect(() => {
    scrollToStartHour();
  }, [hourWidth]);

  useEffect(() => {
    if (Object.keys(props.selectedPractice).length === 0) {
      return;
    }

    const tmpRowHeights = [];
    facilityLocations.forEach(() => tmpRowHeights.push(ROW_HEIGHT));
    setRowHeights(tmpRowHeights);
    setPracticeUsers(selectedPractice.users);

    if (loadDataRef.current) {
      props.toggleCbLoader(true);
      props.loadCaseBlocksData({
        practiceNpi: props.selectedPractice.npi,
        scheduleDate: props.selectedCaseBlockDate,
        scheduleMonth: props.selectedCaseBlockMonth,
        scheduleYear: props.selectedCaseBlockYear,
      });

      props.getProvidersSchedule({
        pUsers: props.selectedPractice.users,
        practiceNpi: props.selectedPractice.npi,
        scheduleDate: props.selectedCaseBlockDate,
        scheduleMonth: props.selectedCaseBlockMonth,
        scheduleYear: props.selectedCaseBlockYear
      });

      scrollToStartHour();
      loadDataRef.current = false;
    }
  }, [props.selectedPractice]);

  useEffect(() => {
    const a = new Date(blkStartYear, blkStartMonth, blkStartDate, blockStartHour, blockStartMinute).getTime();
    const b = new Date(blkEndYear, blkEndMonth, blkEndDate, blockEndHour, blockEndMinute).getTime();
    setShowBlockTimeError(b <= a);
  }, [
    blkStartDate,
    blkStartMonth,
    blkStartYear,
    blockStartHour,
    blockStartMinute,
    blkEndDate,
    blkEndMonth,
    blkEndYear,
    blockEndHour,
    blockEndMinute
  ]);

  useEffect(() => {
    if (props.reloadCaseBlocksData) {
      props.toggleCbLoader(true);
      props.loadCaseBlocksData({
        practiceNpi: props.selectedPractice.npi,
        scheduleDate: props.selectedCaseBlockDate,
        scheduleMonth: props.selectedCaseBlockMonth,
        scheduleYear: props.selectedCaseBlockYear
      });
      scrollToStartHour();
    }
  }, [props.reloadCaseBlocksData]);

  // ____ STATE RESET _________________________________________________________
  const resetState = () => {
    props.resetCaseBlocksState();
    setCaseBlockId(null);
    setInitialCaseData({});
    setActiveLocation({});
    setLocations([]);
    setBlockCases([]);
    setCasesToCreate([]);
    setShowCaseBlockDrawerCloseWarning(false);
    setIsCaseBlockDrawerCloseWarningVisible(false);
    setIsBlkStartTimePristine(true);
    setIsBlkEndTimePristine(true);
    setShowBlockTimeError(false);
  };

  const resetDirectorBlocksDrawerState = () => {
    setDirBlockStartHour(TODAY.getHours());
    setDirBlockStartMinute(TODAY.getMinutes());
    setIsDirBlockStartTimePristine(true);
    setDirBlockStartDate(TODAY.getDate());
    setDirBlockStartMonth(TODAY.getMonth());
    setDirBlockStartYear(TODAY.getFullYear());
    setIsDirBlockStartDatePristine(false);

    setDirBlockStopHour(TODAY.getHours());
    setDirBlockStopMinute(TODAY.getMinutes());
    setIsDirBlockStopTimePristine(true);
    setDirBlockStopDate(TODAY.getDate());
    setDirBlockStopMonth(TODAY.getMonth());
    setDirBlockStopYear(TODAY.getFullYear());
    setIsDirBlockStopDatePristine(false);

    setDirBlockRepeatFrequency("none");
    setSelectedDirector({});
  };

  const resetShiftBlocksDrawerState = () => {
    setShiftBlockStartHour(TODAY.getHours());
    setShiftBlockStartMinute(TODAY.getMinutes());
    setIsShiftBlockStartTimePristine(true);
    setShiftBlockStartDate(TODAY.getDate());
    setShiftBlockStartMonth(TODAY.getMonth());
    setShiftBlockStartYear(TODAY.getFullYear());
    setIsShiftBlockStartDatePristine(false);

    setShiftBlockStopHour(TODAY.getHours());
    setShiftBlockStopMinute(TODAY.getMinutes());
    setIsShiftBlockStopTimePristine(true);
    setShiftBlockStopDate(TODAY.getDate());
    setShiftBlockStopMonth(TODAY.getMonth());
    setShiftBlockStopYear(TODAY.getFullYear());
    setIsShiftBlockStopDatePristine(false);

    setShiftBlockRepeatFrequency("none");
    setSelectedShiftProvider({});
  };

  const resetCallBlocksDrawerState = () => {
    setCallBlockStartHour(TODAY.getHours());
    setCallBlockStartMinute(TODAY.getMinutes());
    setIsCallBlockStartTimePristine(true);
    setCallBlockStartDate(TODAY.getDate());
    setCallBlockStartMonth(TODAY.getMonth());
    setCallBlockStartYear(TODAY.getFullYear());
    setIsCallBlockStartDatePristine(false);

    setCallBlockStopHour(TODAY.getHours());
    setCallBlockStopMinute(TODAY.getMinutes());
    setIsCallBlockStopTimePristine(true);
    setCallBlockStopDate(TODAY.getDate());
    setCallBlockStopMonth(TODAY.getMonth());
    setCallBlockStopYear(TODAY.getFullYear());
    setIsCallBlockStopDatePristine(false);

    setCallBlockRepeatFrequency("none");
    setSelectedCallProvider({});
  };

  // ____ EVENT HANDLERS ______________________________________________________
  const handleOnFacilitySearchValueChanged = (e) => {
    const { value } = e.target;
    setFacilitySearch(value);
  };

  const handleScroll = (e) => {
    const { target } = e;
    const isHorizontalScroll = prvScrollLeft !== target.scrollLeft;
    const isVerticalScroll = prvScrollTop !== target.scrollTop;

    prvScrollTop = target.scrollTop;
    prvScrollLeft = target.scrollLeft;

    if (isHorizontalScroll && !isVerticalScroll) {
      tsHeader.current.style.transform = `translateX(${-1 * target.scrollLeft}px)`;
    }

    if (!isHorizontalScroll && isVerticalScroll) {
      leftRowsRef.current.style.transform = `translateY(${-1 * target.scrollTop}px)`;
    }
  };

  const handleOnMarkCaseForCreation = (newCase) => {
    props.toggleScheduleCaseDrawer(false);

    if (newCase.patientData && newCase.patientData._id) {
      const updatedState = clone(patientData);
      updatedState[newCase.patientData._id] = newCase.patientData;
      setPatientData(updatedState);
    }

    setBlockCases((prvState) => prvState.concat(newCase.caseData));
    const updatedCasesToCreate = clone(casesToCreate);
    updatedCasesToCreate.push(newCase.cData);
    setCasesToCreate(updatedCasesToCreate);
  };

  const handleOnClickAddCase = () => {
    setShowCaseBlockDrawerCloseWarning(true);
    // Preparing Auth Headers
    const reqHeaders = new Headers();
    const reqOptions = {
      method: "GET",
      redirect: "follow",
      headers: reqHeaders,
    };
    const token = localStorage.getItem("token");
    reqHeaders.append("Authorization", `Bearer ${token}`);

    // Facility Data
    const facilityUrl = new URL(`${BASE_URL}/facility/searchFacilities`);
    const facilityParams = { searchTerm: activeLocation.displayName };
    facilityUrl.search = new URLSearchParams(facilityParams).toString();
    fetch(facilityUrl, reqOptions)
      .then((res) => res.text())
      .then((result) => {
        const facData = JSON.parse(result);
        const surgeonsList = [];
        const anesthesiologistsList = [];
        const crnasList = [];

        if (Object.keys(caseBlockSelectedSurgeon).length > 0) {
          const {
            avatarImageUrl,
            specialty,
            credentials,
            fullName = '',
            _id,
            npi,
          } = caseBlockSelectedSurgeon;
          const fullNameParts = fullName.split(',');
          surgeonsList.push({
            addedPractices: [],
            avatarImageUrl,
            caseRelation: specialty,
            credentials,
            firstName: fullNameParts[1].trim() || '',
            lastName: fullNameParts[0].trim() || '',
            fullName: fullName,
            icon: avatarImageUrl,
            id: _id,
            npi,
            text: fullName,
            user: _id,
          });
        }

        if (Object.keys(caseBlockSelectedAnesthesiologist).length > 0) {
          const {
            avatarImageUrl,
            specialty,
            credentials,
            fullName = '',
            _id,
            npi,
          } = caseBlockSelectedAnesthesiologist;

          const fullNameParts = fullName.split(',');

          anesthesiologistsList.push({
            addedPractices: [],
            avatarImageUrl,
            caseRelation: specialty,
            credentials,
            firstName: fullNameParts[1].trim() || '',
            lastName: fullNameParts[0].trim() || '',
            fullName: fullName,
            icon: avatarImageUrl,
            id: _id,
            npi,
            text: fullName,
            user: _id,
            startType: 'anesStart',
            startDate: '',
            startMonth: '',
            startYear: '',
            startHour: '',
            startMinute: '',
            stopType: 'anesStop',
            stopDate: '',
            stopMonth: '',
            stopYear: '',
            stopHour: '',
            stopMinute: ''
          });
        }

        if (Object.keys(caseBlockSelectedCrna).length > 0) {
          const {
            avatarImageUrl,
            specialty,
            credentials,
            fullName = '',
            _id,
            npi,
          } = caseBlockSelectedCrna;

          const fullNameParts = fullName.split(',');

          crnasList.push({
            addedPractices: [],
            avatarImageUrl,
            caseRelation: specialty,
            credentials,
            firstName: fullNameParts[1].trim() || '',
            lastName: fullNameParts[0].trim() || '',
            fullName: fullName,
            icon: avatarImageUrl,
            id: _id,
            npi,
            text: fullName,
            user: _id,
            startType: 'anesStart',
            startDate: '',
            startMonth: '',
            startYear: '',
            startHour: '',
            startMinute: '',
            stopType: 'anesStop',
            stopDate: '',
            stopMonth: '',
            stopYear: '',
            stopHour: '',
            stopMinute: ''
          });
        }

        const caseData = {
          tmpId: Math.random().toString(36).slice(2),
          scheduleStartDate: new Date().toISOString(),
          scheduleEndDate: new Date().toISOString(),
          facility: {
            facility: facData.facilities[0]._id,
            facilityName: facData.facilities[0].facilityName,
            facilityUserName: facData.facilities[0].userName,
            facilityDisplayName: facData.facilities[0].displayName,
            fullName: facData.facilities[0].facilityName,
            icon: facData.facilities[0].avatarImageUrl,
            id: facData.facilities[0]._id,
            locations: facData.facilities[0].locations,
            npi: facData.facilities[0].npi,
            taxonomy: facData.facilities[0].taxonomy,
            text: facData.facilities[0].facilityName,
            user: facData.facilities[0]._id,
          },
          selectedLocation: activeLocation.location,
          selectedFacilityLocation: activeLocation.location,
          surgeons: surgeonsList,
          anesthesiologists: anesthesiologistsList,
          crnas: crnasList,
          isNoneAnesthesiologist: isNoneAnesthesiologist,
          isNoneCrna: isNoneCrna,
        };
        props.setCaseBlockCaseInitialData(caseData);
        props.toggleScheduleCaseDrawer(true);
      })
      .catch((error) => console.log("error", error));
  };

  const handleOnChangeSurgeonSearch = (e) => {
    const { value } = e.target;
    setIsSurgeonSearchPristine(false);
    setSurgeonSearch(value);
    if (value.trim().length > 0) {
      debouncedSurgeonsSearch(value);
    }
  };

  const handleOnChangeAnesthesiologistSearch = (e) => {
    const { value } = e.target;
    setIsAnesthesiologistSearchPristine(false);
    setAnesthesiologistSearch(value);
    if (value.trim().length > 0) {
      debouncedAnesthesiologistsSearch(value);
    }
  };

  const handleOnChangeCrnaSearch = (e) => {
    const { value } = e.target;
    setIsCrnaSearchPristine(false);
    setCrnaSearch(value);
    if (value.trim().length > 0) {
      debouncedCrnasSearch(value);
    }
  };

  const handleOnEditCaseBlock = (cbId, cases = [], patientData = {}) => {
    const cbIdx = caseBlocks.findIndex((el) => el._id === cbId);
    setCaseBlockId(cbId);
    setPatientData(patientData);
    if (cbIdx > -1) {
      const activeCaseBlock = caseBlocks[cbIdx];
      // Active Location
      const facIndex = facilities.findIndex(
        (fac) => fac.id === activeCaseBlock.facilityId,
      );
      if (facIndex > -1) {
        setLocations(facilities[facIndex].locations);
      }

      const fclIdx = facilityLocations.findIndex(
        (el) =>
          el.id ===
          `${activeCaseBlock.facilityId}__${activeCaseBlock.location}`,
      );
      if (fclIdx > -1) {
        setActiveLocation(facilityLocations[fclIdx]);
      }
    }
    props.editCaseBlock(cbId, cases, patientData);
  };

  const handleOnEditCase = (caseData) => {
    debugLogToConsole(caseData);
    if (caseData.isNew) {
      props.editCaseBlockCaseMarkedForCreation(caseData);
      props.toggleScheduleCaseDrawer(true);
    } else {
      props.toggleCbCaseScheduleDashboard(true, caseData._id);
      setShowCaseBlockDrawerCloseWarning(true);
    }
  };

  const handleOnCloseCbScheduleDashboard = () => {
    props.toggleCbCaseScheduleDashboard(false);
  };

  // Update Case Block and Case Schedules
  const handleOnMarkCaseForUpdate = (caseToUpdate) => {
    props.toggleCbCaseScheduleDashboard(false);

    const updatedBlockCases = clone(blockCases);
    const tmpIndex = updatedBlockCases.findIndex(
      (el) => el._id === caseToUpdate.cData._id,
    );
    if (tmpIndex > -1) {
      updatedBlockCases[tmpIndex] = caseToUpdate.cData;
    }
    setBlockCases(updatedBlockCases);
    if (caseToUpdate.patientData._id) {
      const updatedState = clone(patientData);
      updatedState[caseToUpdate.patientData._id] = caseToUpdate.patientData;
      setPatientData(updatedState);
    }
  };

  const linkCaseBlockTimes = () => {
    let isBlockStartTimeNull = true;
    let isBlockEndTimeNull = true;
    let startIdx = -1;
    let endIdx = -1;
    let bsDate = 32530618800000; // Nov 9th, 3000
    let beDate = 0;

    const filteredCaseBlockCaseSchedules = props.caseBlockCaseSchedules.filter(cbCase => {
      if (cbCase.isMarkedForDeletion !== undefined && cbCase.isMarkedForDeletion) {
        return false;
      }
      return true;
    });

    filteredCaseBlockCaseSchedules.forEach((cbCase, idx) => {
      if (
        cbCase.scheduleStartDate !== null &&
        cbCase.scheduleStartHour !== null &&
        cbCase.scheduleStartMinute !== null
      ) {
        const dosParts = cbCase.scheduleStartDate.split("T")[0].split("-");
        const d1 = new Date(
          +dosParts[0],
          +dosParts[1] - 1,
          +dosParts[2],
          cbCase.scheduleStartHour,
          cbCase.scheduleStartMinute,
        );
        if (d1.getTime() < bsDate) {
          bsDate = d1.getTime();
          startIdx = idx;
        }
        isBlockStartTimeNull = false;
      } else {
        isBlockStartTimeNull = true;
      }

      if (
        cbCase.scheduleEndDate !== null &&
        cbCase.scheduleEndHour !== null &&
        cbCase.scheduleEndMinute !== null
      ) {
        const dosParts = cbCase.scheduleEndDate.split("T")[0].split("-");
        const d2 = new Date(
          +dosParts[0],
          +dosParts[1] - 1,
          +dosParts[2],
          cbCase.scheduleEndHour,
          cbCase.scheduleEndMinute,
        );
        if (d2.getTime() > beDate) {
          beDate = d2.getTime();
          endIdx = idx;
        }
        isBlockEndTimeNull = false;
      } else {
        isBlockEndTimeNull = true;
      }
    });

    if (
      !isBlockStartTimeNull &&
      !isBlockEndTimeNull &&
      filteredCaseBlockCaseSchedules.length > 0
    ) {
      // -- Block Linked Start & End Dates
      const tmp1 = filteredCaseBlockCaseSchedules[startIdx].scheduleStartDate.split("T")[0].split("-");
      const tmp2 = filteredCaseBlockCaseSchedules[endIdx].scheduleEndDate.split("T")[0].split("-");

      props.updateCaseBlockData({
        isLinked: true,
        date: makeIsoDateString(scheduleYear, scheduleMonth, scheduleDate),
        linkedStartDate: makeIsoDateString(+tmp1[0], +tmp1[1] - 1, +tmp1[2]),
        linkedStartHour: filteredCaseBlockCaseSchedules[startIdx].scheduleStartHour,
        linkedStartMinute: filteredCaseBlockCaseSchedules[startIdx].scheduleStartMinute,
        linkedEndDate: makeIsoDateString(+tmp2[0], +tmp2[1] - 1, +tmp2[2]),
        linkedEndHour: filteredCaseBlockCaseSchedules[endIdx].scheduleEndHour,
        linkedEndMinute: filteredCaseBlockCaseSchedules[endIdx].scheduleEndMinute,
        blockLinkedTime: `${(beDate - bsDate) / 1000 / 60} mins`
      });
    } else {
      setToastMessage(
        "Cannot determine block start and end times. Plese manually set block time.",
      );
      setShowToastMessage(true);
      setTimeout(() => {
        setShowToastMessage(false);
      }, 5000);
    }
  };

  const unlinkCaseBlockTimes = () => {
    props.updateCaseBlockData({
      date: makeIsoDateString(scheduleYear, scheduleMonth, scheduleDate),
      isLinked: false,
      isBlockStartDatePristine: false,
      blockStartDate: TODAY.toISOString(),
      blockStartMonth: TODAY.getMonth(),
      blockStartYear: TODAY.getFullYear(),
      blockStartHour: 0,
      blockStartMinute: 0,
      isBlockEndDatePristine: false,
      blockEndDate: TODAY.toISOString(),
      blockEndMonth: TODAY.getMonth(),
      blockEndYear: TODAY.getFullYear(),
      isBlockStartTimePristine: true,
      isBlockEndTimePristine: true,
      blockEndHour: 0,
      blockEndMinute: 0,
      blockTime: '? mins'
    });

    setShowBlockTimeError(false);
  };

  const toggleBlockLinkStatus = () => {
    if (isLinked) {
      unlinkCaseBlockTimes();
    } else {
      linkCaseBlockTimes();
    }
  };

  const handleOnRowHeightCalculated = (idx, rowHeight) => {
    const updatedRowHeights = clone(rowHeights);
    updatedRowHeights[idx] = rowHeight;
    setRowHeights(updatedRowHeights);
  };

  const handleOnCloseCaseBlockDrawer = () => {
    if (showCaseBlockDrawerCloseWarning) {
      setIsCaseBlockDrawerCloseWarningVisible(true);
    } else {
      props.toggleCaseBlockDrawer(false);
      resetState();
      props.toggleCbLoader(true);
      props.loadCaseBlocksData({
        practiceNpi: props.selectedPractice.npi,
        scheduleDate: props.selectedCaseBlockDate,
        scheduleMonth: props.selectedCaseBlockMonth,
        scheduleYear: props.selectedCaseBlockYear,
      });

      props.getProvidersSchedule({
        pUsers: props.selectedPractice.users,
        practiceNpi: props.selectedPractice.npi,
        scheduleDate: props.selectedCaseBlockDate,
        scheduleMonth: props.selectedCaseBlockMonth,
        scheduleYear: props.selectedCaseBlockYear,
      });
      scrollToStartHour();
    }
  };

  const handleOnChangeScheduleDate = (year, month, date) => {
    props.setSelectedCaseBlockDate(year, month, date);
    resetState();
    props.toggleCbLoader(true);
    // Reload gantt grid data
    props.loadCaseBlocksData({
      practiceNpi: props.selectedPractice.npi,
      scheduleDate: date,
      scheduleMonth: month,
      scheduleYear: year,
    });

    props.getProvidersSchedule({
      pUsers: props.selectedPractice.users,
      practiceNpi: props.selectedPractice.npi,
      scheduleDate: date,
      scheduleMonth: month,
      scheduleYear: year,
    });

    scrollToStartHour();
  };

  const handleOnClickToggleProviderAvailabilityDrawer = () => {
    setShowProviderAvailabilityDrawer(!showProviderAvailabilityDrawer);
  };

  const handleOnCloseDirectorBlockDrawer = () => {
    setShowDirectorBlockDrawer(false);
    props.toggleCbLoader(true);
    props.loadCaseBlocksData({
      practiceNpi: props.selectedPractice.npi,
      scheduleDate: props.selectedCaseBlockDate,
      scheduleMonth: props.selectedCaseBlockMonth,
      scheduleYear: props.selectedCaseBlockYear,
    });

    props.getProvidersSchedule({
      pUsers: props.selectedPractice.users,
      practiceNpi: props.selectedPractice.npi,
      scheduleDate: props.selectedCaseBlockDate,
      scheduleMonth: props.selectedCaseBlockMonth,
      scheduleYear: props.selectedCaseBlockYear,
    });
  };

  const handleOnClickAddDirectorBlock = () => {
    // Auth Headers
    const myHeaders = new Headers();
    const token = localStorage.getItem("token");
    myHeaders.append("Authorization", `Bearer ${token}`);

    // Form Data
    const formData = new FormData();
    formData.append(
      "date",
      `${scheduleYear}-${padZero(scheduleMonth + 1)}-${padZero(scheduleDate)}T00:00:00.000Z`,
    );
    formData.append("practiceNpi", props.selectedPractice.npi);
    formData.append("facilityNpi", activeAssignment.facilityNpi);
    formData.append("facilityUsername", activeAssignment.facilityUsername);
    formData.append("facilityName", activeAssignment.facilityName);
    formData.append("blockTitle", activeAssignment.title);
    formData.append("startHour", dirBlockStartHour);
    formData.append("startMinute", dirBlockStartMinute);
    formData.append(
      "startDate",
      `${dirBlockStartYear}-${padZero(dirBlockStartMonth + 1)}-${padZero(dirBlockStartDate)}T00:00:00.000Z`,
    );
    formData.append("stopHour", dirBlockStopHour);
    formData.append("stopMinute", dirBlockStopMinute);
    formData.append(
      "stopDate",
      `${dirBlockStopYear}-${padZero(dirBlockStopMonth + 1)}-${padZero(dirBlockStopDate)}T00:00:00.000Z`,
    );
    formData.append(
      "isRepeat",
      JSON.stringify(dirBlockRepeatFrequency.toLowerCase() !== "none"),
    );
    formData.append("repeatFrequency", dirBlockRepeatFrequency);
    formData.append(
      "director",
      JSON.stringify({
        avatarImageUrl: selectedDirector.avatarImageUrl,
        caseRelation: "Director",
        credentials: selectedDirector.credentials,
        fullName: `${selectedDirector.lastName}, ${selectedDirector.firstName}`,
        icon: selectedDirector.avatarImageUrl,
        npi: selectedDirector.npi,
        text: `${selectedDirector.lastName}, ${selectedDirector.firstName}`,
        user: selectedDirector._id,
      }),
    );

    // Req Options
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };

    fetch(`${BASE_URL}/directorBlock/addDirectorBlock`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        const data = JSON.parse(result);
        if (data.success) {
          props.toggleCbLoader(true);
          props.loadCaseBlocksData({
            practiceNpi: props.selectedPractice.npi,
            scheduleDate: props.selectedCaseBlockDate,
            scheduleMonth: props.selectedCaseBlockMonth,
            scheduleYear: props.selectedCaseBlockYear,
          });

          props.getProvidersSchedule({
            pUsers: props.selectedPractice.users,
            practiceNpi: props.selectedPractice.npi,
            scheduleDate: props.selectedCaseBlockDate,
            scheduleMonth: props.selectedCaseBlockMonth,
            scheduleYear: props.selectedCaseBlockYear,
          });
        }

        setShowDirectorBlockDrawer(false);
      })
      .catch((err) => console.log(err));

    setShowDirectorBlockDrawer(false);
  };

  const handleOnClickAddShiftBlock = () => {
    // Auth Headers
    const myHeaders = new Headers();
    const token = localStorage.getItem("token");
    myHeaders.append("Authorization", `Bearer ${token}`);

    // Form Data
    const formData = new FormData();
    formData.append(
      "date",
      `${scheduleYear}-${padZero(scheduleMonth + 1)}-${padZero(scheduleDate)}T00:00:00.000Z`,
    );
    formData.append("practiceNpi", props.selectedPractice.npi);
    formData.append("facilityNpi", activeAssignment.facilityNpi);
    formData.append("facilityUsername", activeAssignment.facilityUsername);
    formData.append("facilityName", activeAssignment.facilityName);
    formData.append("blockTitle", activeAssignment.title);
    formData.append("startHour", shiftBlockStartHour);
    formData.append("startMinute", shiftBlockStartMinute);
    formData.append(
      "startDate",
      `${shiftBlockStartYear}-${padZero(shiftBlockStartMonth + 1)}-${padZero(shiftBlockStartDate)}T00:00:00.000Z`,
    );
    formData.append("stopHour", shiftBlockStopHour);
    formData.append("stopMinute", shiftBlockStopMinute);
    formData.append(
      "stopDate",
      `${shiftBlockStopYear}-${padZero(shiftBlockStopMonth + 1)}-${padZero(shiftBlockStopDate)}T00:00:00.000Z`,
    );
    formData.append(
      "isRepeat",
      JSON.stringify(shiftBlockRepeatFrequency.toLowerCase() === "none"),
    );
    formData.append("repeatFrequency", shiftBlockRepeatFrequency);
    formData.append(
      "provider",
      JSON.stringify({
        avatarImageUrl: selectedShiftProvider.avatarImageUrl,
        caseRelation: "Provider",
        credentials: selectedShiftProvider.credentials,
        fullName: `${selectedShiftProvider.lastName}, ${selectedShiftProvider.firstName}`,
        icon: selectedShiftProvider.avatarImageUrl,
        npi: selectedShiftProvider.npi,
        text: `${selectedShiftProvider.lastName}, ${selectedShiftProvider.firstName}`,
        user: selectedShiftProvider._id,
      }),
    );

    // Req Options
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };

    fetch(`${BASE_URL}/shiftBlock/addShiftBlock`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        const data = JSON.parse(result);
        if (data.success) {
          // getProviderCaseTimes();
          // getData();
        }

        setShowShiftBlockDrawer(false);
      })
      .catch((err) => console.log(err));
  };

  const handleOnClickAddCallBlock = () => {
    // Auth Headers
    const myHeaders = new Headers();
    const token = localStorage.getItem("token");
    myHeaders.append("Authorization", `Bearer ${token}`);

    // Form Data
    const formData = new FormData();
    formData.append(
      "date",
      `${scheduleYear}-${padZero(scheduleMonth + 1)}-${padZero(scheduleDate)}T00:00:00.000Z`,
    );
    formData.append("practiceNpi", props.selectedPractice.npi);
    formData.append("facilityNpi", activeAssignment.facilityNpi);
    formData.append("facilityUsername", activeAssignment.facilityUsername);
    formData.append("facilityName", activeAssignment.facilityName);
    formData.append("blockTitle", activeAssignment.title);
    formData.append("startHour", callBlockStartHour);
    formData.append("startMinute", callBlockStartMinute);
    formData.append(
      "startDate",
      `${callBlockStartYear}-${padZero(callBlockStartMonth + 1)}-${padZero(callBlockStartDate)}T00:00:00.000Z`,
    );
    formData.append("stopHour", callBlockStopHour);
    formData.append("stopMinute", callBlockStopMinute);
    formData.append(
      "stopDate",
      `${callBlockStopYear}-${padZero(callBlockStopMonth + 1)}-${padZero(callBlockStopDate)}T00:00:00.000Z`,
    );
    formData.append(
      "isRepeat",
      JSON.stringify(callBlockRepeatFrequency.toLowerCase() === "none"),
    );
    formData.append("repeatFrequency", callBlockRepeatFrequency);
    formData.append(
      "provider",
      JSON.stringify({
        avatarImageUrl: selectedCallProvider.avatarImageUrl,
        caseRelation: "Provider",
        credentials: selectedCallProvider.credentials,
        fullName: `${selectedCallProvider.lastName}, ${selectedCallProvider.firstName}`,
        icon: selectedCallProvider.avatarImageUrl,
        npi: selectedCallProvider.npi,
        text: `${selectedCallProvider.lastName}, ${selectedCallProvider.firstName}`,
        user: selectedCallProvider._id,
      }),
    );

    // Req Options
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };

    fetch(`${BASE_URL}/callBlock/addCallBlock`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        const data = JSON.parse(result);
        if (data.success) {
          props.toggleCbLoader(true);
          props.loadCaseBlocksData({
            practiceNpi: props.selectedPractice.npi,
            scheduleDate: props.selectedCaseBlockDate,
            scheduleMonth: props.selectedCaseBlockMonth,
            scheduleYear: props.selectedCaseBlockYear,
          });

          props.getProvidersSchedule({
            pUsers: props.selectedPractice.users,
            practiceNpi: props.selectedPractice.npi,
            scheduleDate: props.selectedCaseBlockDate,
            scheduleMonth: props.selectedCaseBlockMonth,
            scheduleYear: props.selectedCaseBlockYear,
          });
        }

        setShowCallBlockDrawer(false);
      })
      .catch((err) => console.log(err));
  };

  const handleOnCloseShiftBlockDrawer = () => {
    setShowShiftBlockDrawer(false);
    props.toggleCbLoader(true);
    props.loadCaseBlocksData({
      practiceNpi: props.selectedPractice.npi,
      scheduleDate: props.selectedCaseBlockDate,
      scheduleMonth: props.selectedCaseBlockMonth,
      scheduleYear: props.selectedCaseBlockYear,
    });

    props.getProvidersSchedule({
      pUsers: props.selectedPractice.users,
      practiceNpi: props.selectedPractice.npi,
      scheduleDate: props.selectedCaseBlockDate,
      scheduleMonth: props.selectedCaseBlockMonth,
      scheduleYear: props.selectedCaseBlockYear,
    });
  };

  const handleOnCloseCallBlockDrawer = () => {
    setShowCallBlockDrawer(false);
    props.toggleCbLoader(true);
    props.loadCaseBlocksData({
      practiceNpi: props.selectedPractice.npi,
      scheduleDate: props.selectedCaseBlockDate,
      scheduleMonth: props.selectedCaseBlockMonth,
      scheduleYear: props.selectedCaseBlockYear,
    });

    props.getProvidersSchedule({
      pUsers: props.selectedPractice.users,
      practiceNpi: props.selectedPractice.npi,
      scheduleDate: props.selectedCaseBlockDate,
      scheduleMonth: props.selectedCaseBlockMonth,
      scheduleYear: props.selectedCaseBlockYear,
    });
  };

  const handleOnChangeDirectorSearch = (e) => {
    const { value } = e.target;
    setIsDirectorSearchPristine(false);
    setDirectorSearch(value);
    if (value.trim().length > 0) {
      debouncedDirectorsSearch(value);
    }
  };

  const handleOnChangeShiftProviderSearch = (e) => {
    const { value } = e.target;
    setIsShiftSearchPristine(false);
    setShiftSearch(value);
    if (value.trim().length > 0) {
      debouncedShiftProvidersSearch(value);
    }
  };

  const handleOnChangeCallProviderSearch = (e) => {
    const { value } = e.target;
    setIsCallSearchPristine(false);
    setCallSearch(value);
    if (value.trim().length > 0) {
      debouncedCallProvidersSearch(value);
    }
  };

  // Left Pinned Rows
  const leftRows = [];
  if (facilityLocations.length > 0) {
    facilityLocations.forEach((location, idx) => {
      let searchPattern = '';
      const facilitySearchParts = facilitySearch.trim().split(' ');
      if (Array.isArray(facilitySearchParts) && facilitySearchParts.length > 1) {
        searchPattern = `(${facilitySearchParts.join('|')})`;
      } else {
        searchPattern = facilitySearch.trim();
      }

      if (new RegExp(searchPattern, 'i').test(location.facilityUserName)) {
        const assignmentType = location.assignmentType || "none";
        const id = location.id || Math.random().toString(36).slice(2);
        const title = location.facilityUserName
          ? `@${location.facilityUserName}`
          : location.displayName;

        leftRows.push(
          <div
            key={id}
            className={`noselect ${css(styles.facilityLocationCell)}`}
            style={{
              height:
                rowHeights.length > 0 && rowHeights[idx]
                  ? `${rowHeights[idx]}px`
                  : `${ROW_HEIGHT}px`,
              // maxHeight: '112px'
              maxHeight: `${ROW_HEIGHT * 2}px`,
              background: location.bgColor,
              color: location.textColor
            }}
          >
            {/* left Side (className='text-truncate') */}
            <div className={css(styles.facilityLocationCellLeft)}>
              <div>{getHighlightedText(title, facilitySearch)}</div>
              <div>{location.location || ""}</div>
            </div>
            {/* Ellipsis */}
            <LeftPinnedEllipsis
              assignmentType={assignmentType}
              showBgColorPicker={() => {
                setBgColor(location.bgColor);
                setFgColor(location.textColor);
                setSelectedFacilityId(location.id.split('__')[0]);
                setShowBgColorPicker(true);
              }}
              openAddCaseDrawer={() => {
                localStorage.setItem(
                  "selectedPractice",
                  JSON.stringify(selectedPractice),
                );
                const facIndex = facilities.findIndex(
                  (fac) => fac.displayName === location.displayName,
                );
                props.initiateNewCaseSchedule({
                  facility: {
                    facility: facilities[facIndex].id,
                    facilityName: facilities[facIndex].facilityName,
                    facilityUserName: facilities[facIndex].userName,
                    facilityDisplayName: facilities[facIndex].displayName,
                    fullName: '',
                    icon: '',
                    id: facilities[facIndex].id,
                    locations: facilities[facIndex].locations,
                    npi: '',
                    taxonomy: facilities[facIndex].taxonomy,
                    text: '',
                    user: facilities[facIndex].id
                  },
                  selectedFacilityLocation: location.location
                });
                localStorage.setItem("loadGanttGrid", JSON.stringify(true));
                history.push("/schedule/create");
              }}
              openDirectionDrawer={() => {
                resetDirectorBlocksDrawerState();
                setShowDirectorBlockDrawer(true);
                setActiveAssignment(location);
              }}
              openShiftDrawer={() => {
                resetShiftBlocksDrawerState();
                setShowShiftBlockDrawer(true);
                setActiveAssignment(location);
              }}
              openCallDrawer={() => {
                resetCallBlocksDrawerState();
                setShowCallBlockDrawer(true);
                setActiveAssignment(location);
              }}
              openCaseBlocksDrawer={() => {
                const facIndex = facilities.findIndex(
                  (fac) => fac.displayName === location.displayName,
                );
                if (facIndex > -1) {
                  setLocations(facilities[facIndex].locations);
                }
                setActiveLocation(location);
                props.toggleCaseBlockDrawer(true);
                const year = TODAY.getFullYear();
                const month = TODAY.getMonth();
                const date = TODAY.getDate();
                props.initiateNewCaseBlock({
                  isNoneCrna: true,
                  isNoneAnesthesiologist: true,
                  facilityId: location.facilityId,
                  facilityName: location.facilityName,
                  location: location.location,
                  // blockStartDate: TODAY.toISOString(),
                  blockStartDate: makeIsoDateString(year, month, date),
                  blockStartMonth: month,
                  blockStartYear: year,
                  isBlockStartTimePristine: true,
                  isBlockEndTimePristine: true,
                  blockStartHour: 0,
                  blockStartMinute: 0,
                  // blockEndDate: TODAY.toISOString(),
                  blockEndDate: makeIsoDateString(year, month, date),
                  blockEndMonth: month,
                  blockEndYear: year,
                  blockEndHour: 0,
                  blockEndMinute: 0
                });
                setBlockCases([]);
              }}
            />
          </div>,
        );
      }
    });
  }

  // Center Rows
  const centerRows = [];
  if (facilityLocations.length > 0) {
    facilityLocations.forEach((el, idx) => {
      let searchPattern = '';
      const facilitySearchParts = facilitySearch.trim().split(' ');
      if (Array.isArray(facilitySearchParts) && facilitySearchParts.length > 1) {
        searchPattern = `(${facilitySearchParts.join('|')})`;
      } else {
        searchPattern = facilitySearch.trim();
      }

      if (!el.assignmentType &&
        el.assignmentType !== "directing" &&
        el.assignmentType !== "shift" &&
        el.assignmentType !== "call" &&
        new RegExp(searchPattern, 'i').test(el.facilityUserName)
      ) {
        const cbData = caseBlocks.filter(
          (cb) =>
            cb.facilityId === el.facilityId && cb.location === el.location,
        );

        // if (cbData.length > 0) {
        //   debugLogToConsole(`---------- Row Index = ${idx} ----------`);
        //   debugLogToConsole(el);
        //   debugLogToConsole(cbData);
        // }

        centerRows.push(
          <GanttRow
            key={`${el.id}__${idx}__row`}
            type='caseblock'
            idx={idx}
            startHour={0}
            endHour={23}
            hourWidth={hourWidth}
            rowHeight={ROW_HEIGHT}
            facilityData={el}
            data={cbData}
            practice={selectedPractice}
            onEditCaseBlock={handleOnEditCaseBlock}
            onRowHeightCalculated={handleOnRowHeightCalculated}
            onReloadData={() => {
              resetState();
              props.toggleCbLoader(true);
              props.loadCaseBlocksData({
                practiceNpi: props.selectedPractice.npi,
                scheduleDate: props.selectedCaseBlockDate,
                scheduleMonth: props.selectedCaseBlockMonth,
                scheduleYear: props.selectedCaseBlockYear,
              });

              props.getProvidersSchedule({
                pUsers: props.selectedPractice.users,
                practiceNpi: props.selectedPractice.npi,
                scheduleDate: props.selectedCaseBlockDate,
                scheduleMonth: props.selectedCaseBlockMonth,
                scheduleYear: props.selectedCaseBlockYear,
              });

              scrollToStartHour();
            }}
          />,
        );
      } else if (el.assignmentType === "directing") {
        const dbData = dirBlocks.filter(
          (db) =>
            +db.facilityNpi === el.facilityNpi && el.title === db.blockTitle,
        );
        centerRows.push(
          <GanttRow
            key={`${el.id}__${idx}__row`}
            type="assignment"
            idx={idx}
            startHour={0}
            endHour={23}
            hourWidth={hourWidth}
            rowHeight={ROW_HEIGHT}
            facilityData={el}
            data={dbData}
            practice={selectedPractice}
            onEditCaseBlock={() => { }}
            onRowHeightCalculated={() => { }}
            onReloadData={() => {
              props.toggleCbLoader(true);
              props.loadCaseBlocksData({
                practiceNpi: props.selectedPractice.npi,
                scheduleDate: props.selectedCaseBlockDate,
                scheduleMonth: props.selectedCaseBlockMonth,
                scheduleYear: props.selectedCaseBlockYear,
              });

              props.getProvidersSchedule({
                pUsers: props.selectedPractice.users,
                practiceNpi: props.selectedPractice.npi,
                scheduleDate: props.selectedCaseBlockDate,
                scheduleMonth: props.selectedCaseBlockMonth,
                scheduleYear: props.selectedCaseBlockYear,
              });
            }}
          />,
        );
      } else if (el.assignmentType === "shift") {
        const sbData = shiftBlocks.filter(
          (sb) =>
            +sb.facilityNpi === el.facilityNpi && el.title === sb.blockTitle,
        );
        centerRows.push(
          <GanttRow
            key={`${el.id}__${idx}__row`}
            type="assignment"
            idx={idx}
            startHour={0}
            endHour={23}
            hourWidth={hourWidth}
            rowHeight={ROW_HEIGHT}
            facilityData={el}
            data={sbData}
            practice={selectedPractice}
            onEditCaseBlock={() => { }}
            onRowHeightCalculated={() => { }}
            onReloadData={() => {
              props.toggleCbLoader(true);
              props.loadCaseBlocksData({
                practiceNpi: props.selectedPractice.npi,
                scheduleDate: props.selectedCaseBlockDate,
                scheduleMonth: props.selectedCaseBlockMonth,
                scheduleYear: props.selectedCaseBlockYear,
              });

              props.getProvidersSchedule({
                pUsers: props.selectedPractice.users,
                practiceNpi: props.selectedPractice.npi,
                scheduleDate: props.selectedCaseBlockDate,
                scheduleMonth: props.selectedCaseBlockMonth,
                scheduleYear: props.selectedCaseBlockYear,
              });
            }}
          />,
        );
      } else if (el.assignmentType === "call") {
        const cbData = callBlocks.filter(
          (cb) =>
            +cb.facilityNpi === el.facilityNpi && el.title === cb.blockTitle,
        );
        centerRows.push(
          <GanttRow
            key={`${el.id}__${idx}__row`}
            type="assignment"
            idx={idx}
            startHour={0}
            endHour={23}
            hourWidth={hourWidth}
            rowHeight={ROW_HEIGHT}
            facilityData={el}
            data={cbData}
            practice={selectedPractice}
            onEditCaseBlock={() => { }}
            onRowHeightCalculated={() => { }}
            onReloadData={() => {
              props.toggleCbLoader(true);
              props.loadCaseBlocksData({
                practiceNpi: props.selectedPractice.npi,
                scheduleDate: props.selectedCaseBlockDate,
                scheduleMonth: props.selectedCaseBlockMonth,
                scheduleYear: props.selectedCaseBlockYear,
              });

              props.getProvidersSchedule({
                pUsers: props.selectedPractice.users,
                practiceNpi: props.selectedPractice.npi,
                scheduleDate: props.selectedCaseBlockDate,
                scheduleMonth: props.selectedCaseBlockMonth,
                scheduleYear: props.selectedCaseBlockYear,
              });
            }}
          />,
        );
      }
    });
  }

  return (
    <div
      className="fx"
      style={{ height: "calc(100% - 64px)" }}
    >
      {/* Provider availability drawer */}
      {showProviderAvailabilityDrawer && (
        <div className={css(styles.providerAvailDrawer)}>
          {/* Header */}
          <div
            className="fx fx__v-center pl-2"
            style={{
              height: "28px",
              background: blue[700],
              color: blue[200],
              fontSize: "14px",
              fontWeight: "700",
            }}
          >
            <div>Provider Availability for&nbsp;</div>
            <div>
              {getShortWeekDay(
                new Date(scheduleYear, scheduleMonth, scheduleDate).getDay(),
              )}
            </div>
            <div>
              &nbsp;
              {`${padZero(scheduleMonth + 1)}/${padZero(scheduleDate)}/${scheduleYear}`}
            </div>
          </div>
          {/* Physician/CRNA & Availability Selector */}
          <div
            className="fx fx__v-center"
            style={{
              height: "32px",
              background: blue[700],
              color: blue[200],
            }}
          >
            {/* Availability filter menu */}
            <div
              style={{ fontSize: "14px", position: "relative" }}
              ref={availMenuRef}
            >
              <div
                className="ml-2"
                style={{
                  minWidth: "90px",
                  color: blue[400],
                  fontWeight: "700",
                }}
                onClick={() => setShowAvailMenu(true)}
              >
                {titleCase(selectedAvailStatus)}
                <i
                  className="fa fa-chevron-down ml-1"
                  onClick={() => setShowAvailMenu(true)}
                />
              </div>
              <PopupMenu
                top={20}
                left={0}
                position="absolute"
                zIndex="2501"
                visible={showAvailMenu}
                parent={availMenuRef}
                onOutsideClick={() => {
                  setShowAvailMenu(false);
                }}
              >
                <div
                  style={{ width: "120px", height: "64px", minHeight: "64px" }}
                  className={css(styles.gridEllipsisMenuContainer)}
                >
                  {/* Available */}
                  <div
                    className={css(
                      styles.gridEllipsisMenuItem,
                      selectedAvailStatus === "available" &&
                      styles.gridEllipsisMenuItemActive,
                    )}
                    onClick={() => {
                      setSelectedAvailStatus("available");
                      setShowAvailMenu(false);
                    }}
                  >
                    Available
                  </div>
                  {/* UnAvailable */}
                  <div
                    className={css(
                      styles.gridEllipsisMenuItem,
                      selectedAvailStatus === "unavailable" &&
                      styles.gridEllipsisMenuItemActive,
                    )}
                    onClick={() => {
                      setSelectedAvailStatus("unavailable");
                      setShowAvailMenu(false);
                    }}
                  >
                    Unavailable
                  </div>
                  {/* All */}
                  <div
                    className={css(
                      styles.gridEllipsisMenuItem,
                      selectedAvailStatus === "all" &&
                      styles.gridEllipsisMenuItemActive,
                    )}
                    onClick={() => {
                      setSelectedAvailStatus("all");
                      setShowAvailMenu(false);
                    }}
                  >
                    All
                  </div>
                </div>
              </PopupMenu>
            </div>
            {/* Provider type filter menu */}
            <div
              className="fx ml-2"
              style={{ fontSize: "14px", position: "relative" }}
              ref={providerMenuRef}
            >
              <div
                className="ml-2"
                style={{
                  minWidth: "90px",
                  color: blue[400],
                  fontWeight: "700",
                }}
                onClick={() => setShowProviderMenu(true)}
              >
                {titleCase(selectedProviderType)}
                <i
                  className="fa fa-chevron-down ml-1"
                  onClick={() => setShowProviderMenu(true)}
                />
              </div>
              <PopupMenu
                top={20}
                left={0}
                position="absolute"
                zIndex="2501"
                visible={showProviderMenu}
                parent={providerMenuRef}
                onOutsideClick={() => {
                  setShowProviderMenu(false);
                }}
              >
                <div
                  style={{ width: "120px", height: "64px", minHeight: "64px" }}
                  className={css(styles.gridEllipsisMenuContainer)}
                >
                  {/* Physicians */}
                  <div
                    className={css(
                      styles.gridEllipsisMenuItem,
                      selectedProviderType === "physicians" &&
                      styles.gridEllipsisMenuItemActive,
                    )}
                    onClick={() => {
                      setSelectedProviderType("physicians");
                      setShowProviderMenu(false);
                    }}
                  >
                    Physicians
                  </div>
                  {/* CRNA */}
                  <div
                    className={css(
                      styles.gridEllipsisMenuItem,
                      selectedProviderType === "crnas" &&
                      styles.gridEllipsisMenuItemActive,
                    )}
                    onClick={() => {
                      setSelectedProviderType("crnas");
                      setShowProviderMenu(false);
                    }}
                  >
                    CRNAs
                  </div>
                  {/* All */}
                  <div
                    className={css(
                      styles.gridEllipsisMenuItem,
                      selectedProviderType === "all" &&
                      styles.gridEllipsisMenuItemActive,
                    )}
                    onClick={() => {
                      setSelectedProviderType("all");
                      setShowProviderMenu(false);
                    }}
                  >
                    All
                  </div>
                </div>
              </PopupMenu>
            </div>
          </div>
          {/* Provider name filter */}
          <div
            className="pb-2 pl-2"
            style={{
              background: blue[700],
              color: blue[200],
            }}
          >
            <TextInputWithLabel
              value={providerSearch}
              titleText="Search"
              titleFontSize={12}
              isCompactLayout={true}
              titleColor={gray[200]}
              textColor={gray[200]}
              selectionColor="white"
              selectionBackground={blue[400]}
              spellcheck={false}
              width={341}
              height={40}
              onChange={(e) => {
                const { value } = e.target;
                setProviderSearch(value);
              }}
            />
          </div>
          <div className={`p-2 ${css(styles.providerAvailDrawerContent)}`}>
            <div>
              {Array.isArray(practiceUsers) &&
                practiceUsers
                  .filter((user) => {
                    if (user.accessType === "Provider") {
                      if (selectedProviderType === "crnas") {
                        return (
                          user.fullName
                            .toLowerCase()
                            .indexOf(providerSearch.toLowerCase()) > -1 &&
                          user.specialty === "CRNA"
                        );
                      } else if (selectedProviderType === "physicians") {
                        return (
                          user.fullName
                            .toLowerCase()
                            .indexOf(providerSearch.toLowerCase()) > -1 &&
                          user.specialty !== "CRNA"
                        );
                      }
                      return (
                        user.fullName
                          .toLowerCase()
                          .indexOf(providerSearch.toLowerCase()) > -1
                      );
                    }
                    return false;
                  })
                  .map((user) => {
                    const tmpDate = new Date(
                      scheduleYear,
                      scheduleMonth,
                      scheduleDate,
                    );
                    const tmpDay = tmpDate.getDay();
                    let statusStr = "";
                    let status = titleCase(
                      user.availabilityRules[tmpDay].status,
                    );
                    let startHour = user.availabilityRules[tmpDay].startHour;
                    let startMinute =
                      user.availabilityRules[tmpDay].startMinute;
                    let endHour = user.availabilityRules[tmpDay].endHour;
                    let endMinute = user.availabilityRules[tmpDay].endHour;
                    const lookupDate = `${padZero(scheduleMonth + 1)}/${padZero(scheduleDate)}/${scheduleYear}`;

                    if (user.dateOverrides && user.dateOverrides[lookupDate]) {
                      const tmpstatus = user.dateOverrides[lookupDate].status;
                      if (tmpstatus) {
                        status = titleCase(tmpstatus);
                        startHour = user.dateOverrides[lookupDate].startHour;
                        startMinute =
                          user.dateOverrides[lookupDate].startMinute;
                        endHour = user.dateOverrides[lookupDate].endHour;
                        endMinute = user.dateOverrides[lookupDate].endMinute;
                      }
                    }

                    if (status === "Available") {
                      statusStr = `${status} ${padZero(startHour)}${padZero(startMinute)} - ${padZero(endHour)}${padZero(endMinute)}`;
                    } else {
                      statusStr = status;
                    }

                    const tmpFullName = user.fullName.split(",");
                    const tmpFirstName = tmpFullName[1].trim().charAt(0);
                    const tmpLastName = tmpFullName[0].trim();

                    if (status === titleCase(selectedAvailStatus)) {
                      // Available & Unavailable
                      return (
                        <div
                          key={user.npi}
                          className="p-1"
                          style={{
                            marginTop: "1px",
                            minHeight: "40px",
                            color: blue[200],
                            background: blue[700],
                            fontSize: "14px",
                            fontWeight: "700",
                          }}
                        >
                          <div>
                            {`${tmpFirstName}.${tmpLastName}, ${user.credentials} / ${statusStr}`}
                          </div>
                          <ul className="m-0 pl-4">
                            {user.casesList && Array.isArray(user.casesList) && user.casesList.length > 0 &&
                              user.casesList.map((cl, idx) => {
                                return (
                                  <li
                                    key={cl.id}
                                    style={{
                                      color: cl.isConcurrent
                                        ? yellow[500]
                                        : blue[200],
                                    }}
                                  >
                                    {cl.text}
                                  </li>
                                );
                              })}
                            {user.casesList.length === 0 && <li>No Cases</li>}
                          </ul>
                          {user.dList.length > 0 && (
                            <ul className="m-0 pl-4">
                              {user.dList.length > 0 &&
                                user.dList.map((dl, idx) => {
                                  return (
                                    <li
                                      key={dl.id}
                                      style={{
                                        color: dl.isConcurrent
                                          ? yellow[500]
                                          : blue[200],
                                      }}
                                    >
                                      {dl.text}
                                    </li>
                                  );
                                })}
                            </ul>
                          )}
                          {user.cList.length > 0 && (
                            <ul className="m-0 pl-4">
                              {user.cList.length > 0 &&
                                user.cList.map((cl, idx) => {
                                  return (
                                    <li
                                      key={cl.id}
                                      style={{
                                        color: cl.isConcurrent
                                          ? yellow[500]
                                          : blue[200],
                                      }}
                                    >
                                      {cl.text}
                                    </li>
                                  );
                                })}
                            </ul>
                          )}
                          {user.sList.length > 0 && (
                            <ul className="m-0 pl-4">
                              {user.sList.length > 0 &&
                                user.sList.map((sl, idx) => {
                                  return (
                                    <li
                                      key={sl.id}
                                      style={{
                                        color: sl.isConcurrent
                                          ? yellow[500]
                                          : blue[200],
                                      }}
                                    >
                                      {sl.text}
                                    </li>
                                  );
                                })}
                            </ul>
                          )}
                        </div>
                      );
                    } else if (titleCase(selectedAvailStatus) === "All") {
                      // All provider types
                      return (
                        <div
                          key={user.npi}
                          className="p-1"
                          style={{
                            marginTop: "1px",
                            minHeight: "40px",
                            color: blue[200],
                            background: blue[700],
                            fontSize: "14px",
                            fontWeight: "700",
                          }}
                        >
                          <div>
                            {`${tmpFirstName}.${tmpLastName}, ${user.credentials} / ${statusStr}`}
                          </div>
                          <ul className="m-0 pl-4">
                            {user.casesList.length > 0 &&
                              user.casesList.map((cl, idx) => {
                                return <li key={cl.id}>{cl.text}</li>;
                              })}
                            {user.casesList.length === 0 && <li>No Cases</li>}
                          </ul>
                          {user.dirTimeStr && (
                            <div>{`Directing: ${user.dirTimeStr}`}</div>
                          )}
                          {user.callTimeStr && (
                            <div>{`On Call: ${user.callTimeStr}`}</div>
                          )}
                          {user.shiftTimeStr && (
                            <div>{`Shift: ${user.shiftTimeStr}`}</div>
                          )}
                        </div>
                      );
                    }
                    return null;
                  })}
            </div>
          </div>
        </div>
      )}
      {/* Gantt Grid */}
      <div className={css(styles.gridParentContainer)}>
        {/* Toolbar  */}
        <div className={css(styles.toolbar)}>
          {/* Left Aligned */}
          <div className="fx fx__v-center">
            {/* Provider availabitlity drawer icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              className="mr-2"
              onClick={handleOnClickToggleProviderAvailabilityDrawer}
            >
              <path fill="#00A0FF" d="M0 0h24v24H0z" />
              <path
                fill="#fff"
                fillRule="evenodd"
                d="M12.92 11.814c2.149 0 3.883-1.745 3.883-3.907S15.069 4 12.92 4 9.039 5.745 9.039 7.907s1.734 3.907 3.882 3.907Zm-.57 1.967c-2.783 0-8.35 1.668-8.35 4.7v1.516h9.84a4.546 4.546 0 0 1-.482-2.044c0-1.555.776-2.928 1.96-3.746-1.088-.282-2.148-.426-2.967-.426Zm3.109 4.36 1.362 1.52 2.451-2.736-.384-.432-2.067 2.308-.978-1.089-.384.429Z"
                clipRule="evenodd"
              />
            </svg>
            <DatePicker
              zIndex={2600}
              className="mb-2"
              left={5}
              date={scheduleDate}
              month={scheduleMonth}
              year={scheduleYear}
              isPrisitine={false}
              noUnderline
              onChangeDate={handleOnChangeScheduleDate}
            />
          </div>
          {/* Right Aligned */}
          <div className="fx fx__v-center">
            {/* Reposition */}
            <div
              className="fx fx__hv-center mr-2"
              style={{
                background: blue[200],
                color: blue[800],
                height: "24px",
                width: "24px",
                borderRadius: "2px",
              }}
              onClick={() => {
                scrollToStartHour();
              }}
            >
              <i className="fa fa-arrows-alt" />
            </div>
            {/* Time scale zoom plus icon */}
            <div
              className="fx fx__hv-center mr-2"
              style={{
                background: hourWidth < 300 ? blue[200] : gray[800],
                color: hourWidth < 300 ? blue[800] : gray[600],
                height: "24px",
                width: "24px",
                borderRadius: "2px",
              }}
              onClick={() => {
                if (hourWidth <= 290) {
                  setHourWidth(Math.min(hourWidth + 10, 300));
                }
              }}
            >
              <i className="fa fa-plus" />
            </div>
            {/* Time scale zoom minus icon */}
            <div
              className="fx fx__hv-center mr-2"
              onClick={() => {
                setHourWidth(Math.max(hourWidth - 10, 100));
              }}
              style={{
                background: hourWidth > 100 ? blue[200] : gray[800],
                color: hourWidth > 100 ? blue[800] : gray[600],
                height: "24px",
                width: "24px",
                borderRadius: "2px",
              }}
            >
              <i className="fa fa-minus" />
            </div>
            {/* Reset Icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
            >
              <path
                fill="#96C8FF"
                fillRule="evenodd"
                d="M1.926 0h20.145C23.136 0 23.997.861 24 1.926v20.148A1.925 1.925 0 0 1 22.074 24H1.926A1.925 1.925 0 0 1 0 22.074V1.926C0 .861.861 0 1.926 0ZM15 12l4-4 4 4h-3c0 4.42-3.58 8-8 8a7.93 7.93 0 0 1-4.26-1.24L9.2 17.3c.83.45 1.79.7 2.8.7 3.31 0 6-2.69 6-6h-3Zm-3-6c-3.31 0-6 2.69-6 6h3l-4 4-4-4h3c0-4.42 3.58-8 8-8 1.57 0 3.03.46 4.26 1.24L14.8 6.7A5.87 5.87 0 0 0 12 6Z"
                clipRule="evenodd"
              />
            </svg>
            {/* Ellipsis Icon */}
            <div
              ref={gridToolbarMenuRef}
              className="fx fx__v-center"
              style={{ position: "relative" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                className="ml-2"
              >
                <path
                  fill="#96C8FF"
                  fillRule="evenodd"
                  d="M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm3 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm12 2a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm-5-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
                  clipRule="evenodd"
                />
              </svg>
              <PopupMenu
                top={24}
                right={2}
                position="absolute"
                zIndex="3000"
                visible={showGridToolbarMenu}
                parent={gridToolbarMenuRef}
                onOutsideClick={() => {
                  setShowGridToolbarMenu(false);
                }}
              >
                <div
                  className={css(styles.gridEllipsisMenuContainer)}
                  style={{ minWidth: "150px" }}
                >
                  {/* Show Case Blocks Drawer */}
                  <div
                    className={css(styles.gridEllipsisMenuItem)}
                    onClick={() => {
                      setShowGridToolbarMenu(false);
                    }}
                  >
                    Add Case Block
                  </div>
                </div>
              </PopupMenu>
            </div>
          </div>
        </div>

        {/* Toast Message */}
        {showToastMessage && (
          <Toast
            id="toast_1"
            top="41"
            bottom={null}
            headerText="Warnring"
            headerIcon="fa fa-exclamation-triangle"
            bodyText={toastMessage}
            onDismiss={() => {
              setShowToastMessage(false);
            }}
            showFooter={false}
          />
        )}

        {/* Case Block Drawer Close Warning Dialog */}
        {isCaseBlockDrawerCloseWarningVisible && (
          <WarningDialog
            show={isCaseBlockDrawerCloseWarningVisible}
            title="Close Case Block Drawer"
            message="Do you want to close without saving?"
            onCancel={() => setIsCaseBlockDrawerCloseWarningVisible(false)}
            onContinue={() => {
              props.toggleCaseBlockDrawer(false);
              resetState();
              props.toggleCbLoader(true);
              props.loadCaseBlocksData({
                practiceNpi: props.selectedPractice.npi,
                scheduleDate: props.selectedCaseBlockDate,
                scheduleMonth: props.selectedCaseBlockMonth,
                scheduleYear: props.selectedCaseBlockYear,
              });

              props.getProvidersSchedule({
                pUsers: props.selectedPractice.users,
                practiceNpi: props.selectedPractice.npi,
                scheduleDate: props.selectedCaseBlockDate,
                scheduleMonth: props.selectedCaseBlockMonth,
                scheduleYear: props.selectedCaseBlockYear,
              });
            }}
          />
        )}

        {/* --- Case Blocks Drawer - Create/Edit case blocks --- */}
        {props.showCaseBlockDrawer &&
          <Drawer
            placement="right"
            visible={props.showCaseBlockDrawer}
            toggleDrawer={handleOnCloseCaseBlockDrawer}
            zIndex="2000"
            width={window.innerWidth <= 700 ? window.innerWidth : 375}
          >
            <div className={css(styles.sideDrawerContainer)}>
              {/* Header */}
              <div className={css(styles.sideDrawerHeader)}>
                {/* Facility | Locationa & Icons (Top Row) */}
                <div className={css(styles.sideDrawerHeaderTopRow)}>
                  {/* Left aligned -- Facility and location */}
                  <div className="fx fx__hv-center">
                    <div className="fx">
                      <div
                        className="text-truncate"
                        style={{ maxWidth: "180px" }}
                      >
                        {activeLocation.displayName || ""}
                      </div>
                      <div className="ml-2 mr-2">|</div>
                      <div
                        style={{
                          color: blue[400],
                          position: "relative",
                          minWidth: "75px",
                        }}
                        ref={locationRef}
                      >
                        {activeLocation.location || ""}
                        <i
                          className="fa fa-chevron-down ml-1"
                          onClick={() => setShowLocationMenu(!showLocationMenu)}
                        />
                        <PopupMenu
                          top={24}
                          left={2}
                          position="absolute"
                          zIndex="3000"
                          visible={showLocationMenu}
                          parent={locationRef}
                          onOutsideClick={() => {
                            setShowLocationMenu(false);
                          }}
                        >
                          <div
                            className={css(styles.gridEllipsisMenuContainer)}
                            style={{ maxWidth: "140px" }}
                          >
                            {locations.map((loc, idx) => {
                              return (
                                <div
                                  key={`${loc}__${idx}`}
                                  style={{ maxWidth: "140px" }}
                                  className={css(styles.gridEllipsisMenuItem)}
                                  onClick={() => {
                                    const updatedActiveLocation =
                                      clone(activeLocation);
                                    setShowCaseBlockDrawerCloseWarning(true);
                                    setActiveLocation({
                                      ...updatedActiveLocation,
                                      location: loc,
                                    });
                                    props.updateCaseBlockData({
                                      location: loc
                                    });
                                    setShowLocationMenu(!showLocationMenu);
                                  }}
                                >
                                  <div className="text-truncate">{loc}</div>
                                </div>
                              );
                            })}
                          </div>
                        </PopupMenu>
                      </div>
                    </div>
                  </div>
                  {/* Right aligned icons */}
                  <div className="fx fx__v-center">
                    {/* Add Case */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="none"
                      onClick={handleOnClickAddCase}
                    >
                      <path
                        fill="#96C8FF"
                        fillRule="evenodd"
                        d="M18 4.21h-4V2.106C14 .937 13.11 0 12 0H8C6.89 0 6 .937 6 2.105v2.106H2C.89 4.21.01 5.147.01 6.316L0 17.895C0 19.063.89 20 2 20h16c1.11 0 2-.937 2-2.105V6.315c0-1.168-.89-2.104-2-2.104Zm-6-.205H8v-2h4v2Zm-1.257 8.824h3.733a.733.733 0 0 0 .732-.736.733.733 0 0 0-.732-.735h-3.733V7.61a.733.733 0 1 0-1.465 0v3.748H5.524a.733.733 0 0 0-.732.736c0 .406.327.735.732.735h3.754v3.727a.733.733 0 1 0 1.465 0V12.83Z"
                        clipRule="evenodd"
                      />
                    </svg>
                    {/* Ellipsis */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="none"
                      className="ml-2"
                    >
                      <path
                        fill="#96C8FF"
                        fillRule="evenodd"
                        d="M2 0a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm2.167 8.333a1.667 1.667 0 1 0 0 3.334 1.667 1.667 0 0 0 0-3.334Zm10 1.667a1.667 1.667 0 1 1 3.333 0 1.667 1.667 0 0 1-3.333 0ZM10 8.333a1.667 1.667 0 1 0 0 3.334 1.667 1.667 0 0 0 0-3.334Z"
                        clipRule="evenodd"
                      />
                    </svg>
                    {/* Collapse */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="none"
                      className="ml-2"
                      onClick={handleOnCloseCaseBlockDrawer}
                    >
                      <path
                        fill="#96C8FF"
                        fillRule="evenodd"
                        d="M2 0a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm8.92 9.464h3.587a.491.491 0 1 0 0-.983h-2.359l2.594-2.59a.49.49 0 1 0-.695-.693l-2.634 2.63V5.491a.491.491 0 0 0-.983 0v3.483a.49.49 0 0 0 .49.49Zm-5.43 2.05h2.36l-2.593 2.59a.49.49 0 1 0 .695.694l2.635-2.63v2.337a.491.491 0 0 0 .983 0v-3.483a.491.491 0 0 0-.491-.49H5.492a.491.491 0 0 0-.001.982Z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                </div>
                {/* ___ Case Block Surgeon Section ___ */}
                <div className={css(styles.sideDrawerHeaderRow)}>
                  {/* Title */}
                  <div style={{ minWidth: "62px" }}>Surgeon</div>
                  {/* Case Block Surgeon */}
                  <div
                    className="cursor__pointer ml-2"
                    style={{ color: blue[400], position: "relative" }}
                    ref={surgMenuRef}
                  >
                    <div
                      onClick={() => {
                        setSurgeonSearch("");
                        setIsSurgeonSearchPristine(true);
                        setSurgeons([]);
                        setShowSurgMenu(!showSurgMenu);
                      }}
                    >
                      {Object.keys(surgeon).length > 0
                        ? `${surgeon.fullName} ${surgeon.credentials}`
                        : '? Select'
                      }
                      <i className="fa fa-chevron-down ml-1" />
                    </div>
                    <PopupMenu
                      top={1}
                      left={1}
                      position="absolute"
                      zIndex="3000"
                      visible={showSurgMenu}
                      parent={surgMenuRef}
                      onOutsideClick={() => {
                        setShowSurgMenu(false);
                      }}
                    >
                      <div className={css(styles.gridEllipsisMenuContainer)}>
                        {/* Surgeon search textbox */}
                        <div className="pl-2 pt-1">
                          <TextInput
                            placeholder="Search Surgeon"
                            value={surgeonSearch}
                            onChange={handleOnChangeSurgeonSearch}
                            style={{
                              width: "204px",
                              height: "20px",
                              background: "#103a60",
                              border: "1px solid #60A0E0",
                              borderWidth: "0 0 1px 0",
                              marginBottom: "2px",
                              fontSize: "12px",
                              fontWeight: "700",
                            }}
                          />
                        </div>
                        {surgeons.length === 0 && isSurgeonSearchPristine && (
                          <div
                            style={{
                              fontSize: "14px",
                              padding: "8px",
                              color: gray[300],
                            }}
                          >
                            Type surgeon name in the text box above to search
                          </div>
                        )}
                        {surgeons.length === 0 &&
                          !isSurgeonSearchPristine &&
                          surgeonSearch.length === 0 && (
                            <div
                              style={{
                                fontSize: "14px",
                                padding: "8px",
                                color: gray[300],
                              }}
                            >
                              Type surgeon name in the text box above to search
                            </div>
                        )}
                        {surgeons.length === 0 &&
                          !isSurgeonSearchPristine &&
                          surgeonSearch.length > 0 && (
                            <div
                              style={{
                                fontSize: "14px",
                                padding: "8px",
                                color: gray[300],
                              }}
                            >
                              No results found
                            </div>
                        )}
                        {surgeons.map((surg) => {
                          return (
                            <div
                              key={`${surg.npi}__surg`}
                              className={css(styles.gridEllipsisMenuItem)}
                              onClick={() => {
                                setShowCaseBlockDrawerCloseWarning(true);
                                // setCaseBlockSelectedSurgeon(surg);
                                props.updateCaseBlockData({
                                  surgeon: {
                                    avatarImageUrl: surg.avatarImageUrl,
                                    caseRelation: surg.specialty,
                                    credentials: surg.credentials,
                                    fullName: `${surg.lastName}, ${surg.firstName}`,
                                    icon: surg.avatarImageUrl,
                                    npi: surg.npi,
                                    text: `${surg.lastName}, ${surg.firstName}`,
                                    user: surg._id
                                  }
                                });
                                setShowSurgMenu(!showSurgMenu);
                              }}
                            >
                              {`${surg.lastName}, ${surg.firstName} ${surg.credentials}`}
                            </div>
                          );
                        })}
                      </div>
                    </PopupMenu>
                  </div>
                </div>
                {/* ___ Case Block Anesthesiologist Section ___ */}
                <div className={css(styles.sideDrawerHeaderRow)}>
                  {/* None Checkbox */}
                  <div>
                    <Checkbox
                      text=""
                      isChecked={!isNoneAnesthesiologist}
                      onChange={() => {
                        setShowCaseBlockDrawerCloseWarning(true);
                        // setCaseBlockSelectedAnesthesiologist({});
                        // setIsNoneAnesthesiologist(!isNoneAnesthesiologist);
                        props.updateCaseBlockData({
                          anesthesiologist: {},
                          isNoneAnesthesiologist: !isNoneAnesthesiologist
                        });
                      }}
                    />
                  </div>
                  {/* Title */}
                  <div style={{ minWidth: "44px" }}>Anes</div>
                  {/* Anesthesiologist */}
                  <div
                    className="cursor__pointer"
                    style={{
                      color: Object.keys(anesthesiologist).length > 0 ? blue[400] : salmon[500],
                      position: "relative",
                      display: isNoneAnesthesiologist ? 'none' : '',
                    }}
                    ref={anesMenuRef}
                  >
                    <div
                      onClick={() => {
                        setAnesthesiologistSearch("");
                        setIsAnesthesiologistSearchPristine(true);
                        setAnesthesiologists([]);
                        setShowAnesMenu(!showAnesMenu);
                      }}
                    >
                      {Object.keys(anesthesiologist).length > 0
                        ? `${anesthesiologist.fullName} ${anesthesiologist.credentials}`
                        : '? Select'
                      }
                      <i className="fa fa-chevron-down ml-1" />
                    </div>
                    <PopupMenu
                      top={1}
                      left={1}
                      position="absolute"
                      zIndex="3000"
                      visible={showAnesMenu}
                      parent={anesMenuRef}
                      onOutsideClick={() => {
                        setShowAnesMenu(false);
                      }}
                    >
                      <div className={css(styles.gridEllipsisMenuContainer)}>
                        {/* Anesthesiologist search textbox */}
                        <div className="pl-2 pt-1">
                          <TextInput
                            placeholder="Search Anesthesiologist"
                            value={anesthesiologistSearch}
                            onChange={handleOnChangeAnesthesiologistSearch}
                            style={{
                              width: "204px",
                              height: "20px",
                              background: "#103a60",
                              border: "1px solid #60A0E0",
                              borderWidth: "0 0 1px 0",
                              marginBottom: "2px",
                              fontSize: "12px",
                              fontWeight: "700",
                            }}
                          />
                        </div>
                        {anesthesiologists.length === 0 &&
                          isAnesthesiologistSearchPristine && (
                            <div
                              style={{
                                fontSize: "14px",
                                padding: "8px",
                                color: gray[300],
                              }}
                            >
                              Type anesthesiologist name in the text box above
                              to search
                            </div>
                        )}
                        {anesthesiologists.length === 0 &&
                          !isAnesthesiologistSearchPristine &&
                          anesthesiologistSearch.length === 0 && (
                            <div
                              style={{
                                fontSize: "14px",
                                padding: "8px",
                                color: gray[300],
                              }}
                            >
                              Type anesthesiologist name in the text box above
                              to search
                            </div>
                        )}
                        {anesthesiologists.length === 0 &&
                          !isAnesthesiologistSearchPristine &&
                          anesthesiologistSearch.length > 0 && (
                            <div
                              style={{
                                fontSize: "14px",
                                padding: "8px",
                                color: gray[300],
                              }}
                            >
                              No results found
                            </div>
                        )}
                        {anesthesiologists.map((anes) => {
                          return (
                            <div
                              key={`${anes.npi}__anes`}
                              className={css(styles.gridEllipsisMenuItem)}
                              onClick={() => {
                                setShowCaseBlockDrawerCloseWarning(true);
                                // setCaseBlockSelectedAnesthesiologist(anes);
                                props.updateCaseBlockData({
                                  anesthesiologist: {
                                    avatarImageUrl: anes.avatarImageUrl,
                                    caseRelation: "Anesthesiologist",
                                    credentials: anes.credentials,
                                    fullName: `${anes.lastName}, ${anes.firstName}`,
                                    icon: anes.avatarImageUrl,
                                    npi: anes.npi,
                                    text: `${anes.lastName}, ${anes.firstName}`,
                                    user: anes._id
                                  }
                                });
                                setShowAnesMenu(!showAnesMenu);
                              }}
                            >
                              {`${anes.lastName}, ${anes.firstName} ${anes.credentials}`}
                            </div>
                          );
                        })}
                      </div>
                    </PopupMenu>
                  </div>
                </div>
                {/* ___ Case Block CRNA Section ___ */}
                <div className={`mb-1 ${css(styles.sideDrawerHeaderRow)}`}>
                  {/* None Checkbox */}
                  <div>
                    <Checkbox
                      text=""
                      isChecked={!isNoneCrna}
                      onChange={() => {
                        setShowCaseBlockDrawerCloseWarning(true);
                        props.updateCaseBlockData({
                          crna: {},
                          isNoneCrna: !isNoneCrna
                        });
                      }}
                    />
                  </div>
                  {/* Title */}
                  <div style={{ minWidth: "44px" }}>CRNA</div>
                  {/* Case Block CRNA */}
                  <div
                    className="cursor__pointer"
                    style={{
                      color: Object.keys(caseBlockSelectedCrna).length > 0 ? blue[400] : salmon[500],
                      position: "relative",
                      display: isNoneCrna ? 'none' : '',
                    }}
                    ref={crnaMenuRef}
                  >
                    <div
                      onClick={() => {
                        setCrnaSearch("");
                        setIsCrnaSearchPristine(true);
                        setCrnas([]);
                        setShowCrnaMenu(!showCrnaMenu);
                      }}
                    >
                      {Object.keys(crna).length > 0 ? `${crna.fullName} ${crna.credentials}` : '? Select'}
                      <i className="fa fa-chevron-down ml-1" />
                    </div>
                    <PopupMenu
                      top={1}
                      left={1}
                      position="absolute"
                      zIndex="3000"
                      visible={showCrnaMenu}
                      parent={crnaMenuRef}
                      onOutsideClick={() => {
                        setShowCrnaMenu(false);
                      }}
                    >
                      <div className={css(styles.gridEllipsisMenuContainer)}>
                        {/* Surgeon search textbox */}
                        <div className="pl-2 pt-1">
                          <TextInput
                            placeholder="Search CRNA"
                            value={crnaSearch}
                            onChange={handleOnChangeCrnaSearch}
                            style={{
                              width: "204px",
                              height: "20px",
                              background: "#103a60",
                              border: "1px solid #60A0E0",
                              borderWidth: "0 0 1px 0",
                              marginBottom: "2px",
                              fontSize: "12px",
                              fontWeight: "700",
                            }}
                          />
                        </div>
                        {crnas.length === 0 && isCrnaSearchPristine && (
                          <div
                            style={{
                              fontSize: "14px",
                              padding: "8px",
                              color: gray[300],
                            }}
                          >
                            Type CRNA name in the text box above to search
                          </div>
                        )}
                        {crnas.length === 0 &&
                          !isCrnaSearchPristine &&
                          crnaSearch.length === 0 && (
                            <div
                              style={{
                                fontSize: "14px",
                                padding: "8px",
                                color: gray[300],
                              }}
                            >
                              Type CRNA name in the text box above to search
                            </div>
                        )}
                        {crnas.length === 0 &&
                          !isCrnaSearchPristine &&
                          crnaSearch.length > 0 && (
                            <div
                              style={{
                                fontSize: "14px",
                                padding: "8px",
                                color: gray[300],
                              }}
                            >
                              No results found
                            </div>
                        )}
                        {crnas.map((crna) => {
                          return (
                            <div
                              key={`${crna.npi}__crna`}
                              className={css(styles.gridEllipsisMenuItem)}
                              onClick={() => {
                                setShowCaseBlockDrawerCloseWarning(true);
                                // setCaseBlockSelectedCrna(crna);
                                props.updateCaseBlockData({
                                  crna: {
                                    avatarImageUrl: crna.avatarImageUrl,
                                    caseRelation: "CRNA",
                                    credentials: crna.credentials,
                                    fullName: `${crna.lastName}, ${crna.firstName}`,
                                    icon: crna.avatarImageUrl,
                                    npi: crna.npi,
                                    text: `${crna.lastName}, ${crna.firstName}`,
                                    user: crna._id
                                  }
                                });
                                setShowCrnaMenu(!showCrnaMenu);
                              }}
                            >
                              {`${crna.lastName}, ${crna.firstName} ${crna.credentials}`}
                            </div>
                          );
                        })}
                      </div>
                    </PopupMenu>
                  </div>
                </div>
                {/* Link block times to cases times */}
                <div
                  className="mb-1"
                  style={{
                    width: "100%",
                    background: blue[900],
                  }}
                >
                  {/* Block Time Heading */}
                  <div className="fx fx__v-center p-1">
                    {/* Link Icon */}
                    <div
                      style={{ height: "24px", width: "24px" }}
                      className="fx fx__hv-center"
                      onClick={toggleBlockLinkStatus}
                    >
                      {isLinked
                        ? <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          fill="none"
                        >
                          <path
                            fill="#00A0FF"
                            fillRule="evenodd"
                            d="M15.934 2.066a3.646 3.646 0 0 0-5.153 0l-3.21 3.209a.642.642 0 0 0 0 .912.643.643 0 0 0 .913 0l3.21-3.209a2.355 2.355 0 0 1 3.325 0c.443.443.69 1.034.69 1.66 0 .63-.245 1.219-.69 1.661L11.81 9.508a.642.642 0 0 0 .458 1.1c.166 0 .33-.063.457-.188l3.21-3.208a3.638 3.638 0 0 0-.001-5.146ZM10.539 6.58l-3.805 3.805c-.26.264-.445.546-.531.801-.09.257-.084.478.041.603.249.254.878.033 1.403-.491l3.8-3.803c.524-.521.745-1.15.492-1.403-.246-.257-.876-.036-1.4.488Zm-4.233 8.432 3.208-3.208a.648.648 0 0 1 .915 0 .642.642 0 0 1 0 .912l-3.212 3.207a3.622 3.622 0 0 1-2.574 1.066c-.931 0-1.864-.355-2.575-1.066A3.606 3.606 0 0 1 1 13.35c0-.971.379-1.886 1.068-2.575l3.21-3.205a.643.643 0 0 1 .914 0 .642.642 0 0 1 0 .913l-3.21 3.208a2.341 2.341 0 0 0 .002 3.321c.442.445 1.032.69 1.66.69.627 0 1.219-.247 1.662-.69Z"
                            clipRule="evenodd"
                          />
                          <path
                            fill="#00A0FF"
                            d="m10.781 2.066-.176-.177.176.177Zm5.153 0-.177.177.177-.177ZM7.57 5.275l-.177-.177.177.177Zm0 .912.177-.177-.001-.001-.176.178Zm.913 0-.177-.177-.001.001.178.176Zm3.21-3.209.177.177-.177-.177Zm3.325 0 .177-.176-.177.176Zm0 3.321-.176-.177.176.177ZM11.81 9.508l.177.177-.177-.177Zm0 .912.177-.177h-.001l-.176.177Zm.915 0 .176.178-.176-.178Zm3.21-3.208-.176-.177.176.177Zm-9.2 3.173-.177-.177h-.001l.177.177Zm-.532.801.236.083v-.003l-.236-.08Zm.041.603.179-.175-.002-.002-.177.177Zm1.403-.491.177.176-.177-.176Zm3.8-3.803-.176-.178.177.178Zm.492-1.403-.18.173.003.003.177-.176Zm-2.425 5.712-.176-.178v.001l.176.177Zm-3.208 3.208.177.177-.177-.177Zm4.123-3.208-.176.177.176-.177Zm0 .912.177.177-.177-.177Zm-3.212 3.207-.177-.177.177.177Zm-5.149 0 .177-.177-.177.177Zm0-5.148-.176-.177.176.177Zm3.21-3.205.177.177.002-.001-.178-.176Zm.914 0-.177.177.001.001.176-.178Zm0 .913.176.177-.176-.177Zm-3.21 3.208.176.177-.177-.177Zm.001 3.321-.177.177.177-.177Zm7.975-12.77a3.396 3.396 0 0 1 4.799 0l.353-.353a3.896 3.896 0 0 0-5.505 0l.353.354Zm-3.21 3.21 3.21-3.21-.353-.353-3.21 3.209.353.353Zm-.001.557a.392.392 0 0 1 0-.558l-.353-.353a.892.892 0 0 0 .002 1.267l.35-.356Zm.559.002a.393.393 0 0 1-.558 0l-.354.353c.351.35.92.352 1.268-.002l-.356-.35Zm3.212-3.21-3.21 3.21.353.353 3.21-3.209-.353-.353Zm3.678 0a2.605 2.605 0 0 0-3.678 0l.353.354a2.105 2.105 0 0 1 2.971 0l.354-.353Zm.763 1.838c0-.694-.274-1.348-.763-1.837l-.354.353c.397.396.617.924.617 1.484h.5Zm-.764 1.838c.492-.49.764-1.143.764-1.838h-.5c0 .562-.219 1.087-.616 1.483l.352.355Zm-3.208 3.208 3.209-3.209-.354-.353-3.208 3.208.353.354Zm-.001.557a.392.392 0 0 1 .001-.557l-.353-.354a.892.892 0 0 0 .001 1.267l.35-.356Zm.282.116a.395.395 0 0 1-.28-.115l-.354.354c.175.175.405.26.634.26v-.5Zm.282-.116a.398.398 0 0 1-.282.116v.5c.23 0 .457-.087.633-.26l-.351-.356Zm3.209-3.207-3.21 3.208.353.354 3.21-3.208-.353-.354Zm-.002-4.792a3.388 3.388 0 0 1 .002 4.792l.353.354a3.888 3.888 0 0 0-.002-5.5l-.353.354Zm-8.846 8.319 3.805-3.805-.354-.353-3.804 3.804.353.354Zm-.471.704c.07-.21.23-.46.472-.705l-.355-.352c-.28.283-.49.597-.591.898l.474.16Zm-.02.346c-.016-.017-.064-.107.019-.343l-.472-.165c-.097.277-.133.629.1.862l.354-.354Zm1.05-.491c-.241.242-.5.404-.71.478-.231.081-.32.033-.337.015l-.357.35c.23.236.581.204.859.107.296-.104.616-.314.899-.597l-.354-.353Zm3.8-3.803-3.8 3.803.354.353 3.8-3.803-.353-.353Zm.492-1.05c.02.02.067.112-.014.342a1.985 1.985 0 0 1-.477.707l.353.355c.283-.281.492-.6.596-.897.098-.278.129-.627-.104-.86l-.354.353Zm-1.046.49a2 2 0 0 1 .71-.479c.23-.08.317-.031.333-.014l.36-.346c-.23-.24-.58-.209-.858-.112-.296.104-.616.314-.899.597l.354.353Zm-1.378 4.869-3.209 3.208.354.354L9.69 11.98l-.353-.353Zm1.267 0a.898.898 0 0 0-1.267 0l.352.354a.398.398 0 0 1 .563 0l.352-.355Zm0 1.266a.892.892 0 0 0 0-1.267l-.351.356c.153.151.155.4-.002.557l.354.354ZM7.395 16.1l3.212-3.207-.354-.354-3.212 3.207.354.354Zm-2.751 1.139c.995 0 1.995-.38 2.751-1.14l-.354-.352a3.373 3.373 0 0 1-2.397.992v.5Zm-2.751-1.14c.76.76 1.756 1.14 2.75 1.14v-.5c-.867 0-1.735-.331-2.397-.993l-.353.354ZM.75 13.35c0 1.037.405 2.017 1.142 2.75l.353-.354a3.356 3.356 0 0 1-.995-2.396h-.5Zm1.142-2.752A3.866 3.866 0 0 0 .75 13.35h.5c0-.905.352-1.755.995-2.398l-.353-.354Zm3.21-3.205-3.21 3.205.353.354 3.21-3.205-.353-.354Zm1.266 0a.893.893 0 0 0-1.267.002l.356.35a.393.393 0 0 1 .558.002l.353-.354Zm0 1.267a.892.892 0 0 0-.001-1.268l-.351.356c.154.152.155.401-.001.558l.353.354Zm-3.21 3.208 3.21-3.208-.353-.354-3.21 3.208.353.354Zm-.616 1.484c0-.562.218-1.088.616-1.484l-.353-.354a2.576 2.576 0 0 0-.763 1.838h.5Zm.618 1.484a2.091 2.091 0 0 1-.618-1.484h-.5c0 .694.275 1.346.764 1.837l.354-.353Zm1.484.615a2.079 2.079 0 0 1-1.484-.615l-.354.353c.49.492 1.143.762 1.838.762v-.5Zm1.485-.616a2.09 2.09 0 0 1-1.485.616v.5c.694 0 1.349-.273 1.839-.762l-.354-.354Z"
                          />
                        </svg>
                        : <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          fill="none"
                        >
                          <path
                            fill="#00A0FF"
                            fillRule="evenodd"
                            d="M10.781 2.066a3.646 3.646 0 0 1 5.153 0 3.638 3.638 0 0 1 .001 5.146l-3.21 3.208a.648.648 0 0 1-.915 0 .642.642 0 0 1 0-.912l3.209-3.209c.445-.442.69-1.032.69-1.66a2.355 2.355 0 0 0-4.014-1.66L8.483 6.186a.643.643 0 0 1-.913 0 .642.642 0 0 1 0-.912l3.21-3.21ZM6.306 15.012l3.208-3.208a.648.648 0 0 1 .915 0 .642.642 0 0 1 0 .912l-3.212 3.207a3.622 3.622 0 0 1-2.574 1.066c-.931 0-1.864-.355-2.575-1.066A3.606 3.606 0 0 1 1 13.35c0-.971.379-1.886 1.068-2.575l3.21-3.205a.643.643 0 0 1 .914 0 .642.642 0 0 1 0 .913l-3.21 3.208a2.341 2.341 0 0 0 .002 3.321c.442.445 1.032.69 1.66.69.627 0 1.219-.247 1.662-.69Z"
                            clipRule="evenodd"
                          />
                          <path
                            fill="#00A0FF"
                            d="m15.934 2.066-.177.177.177-.177Zm-5.153 0-.176-.177.176.177Zm5.154 5.146-.176-.177.176.177Zm-3.21 3.208.176.178-.176-.178Zm-.915 0 .177-.177h-.001l-.176.177Zm0-.912.177.177-.177-.177Zm3.209-3.209-.176-.177.176.177Zm0-3.32.177-.177-.177.176Zm-3.325 0 .177.176-.177-.177Zm-3.21 3.208-.177-.177-.001.001.178.176Zm-.913 0 .177-.177-.001-.001-.176.178Zm0-.912-.177-.177.177.177Zm1.943 6.529-.176-.178v.001l.176.177Zm-3.208 3.208.177.177-.177-.177Zm4.123-3.208-.176.177.176-.177Zm0 .912.177.177-.177-.177Zm-3.212 3.207-.177-.177.177.177Zm-5.149 0 .177-.177-.177.177Zm0-5.148-.176-.177.176.177Zm3.21-3.205.177.177.002-.001-.178-.176Zm.914 0-.177.177.001.001.176-.178Zm0 .913.176.177-.176-.177Zm-3.21 3.208.176.177-.177-.177Zm.001 3.321-.177.177.177-.177ZM16.11 1.89a3.896 3.896 0 0 0-5.505 0l.353.354a3.396 3.396 0 0 1 4.799 0l.353-.354Zm.002 5.5a3.888 3.888 0 0 0-.002-5.5l-.353.354a3.388 3.388 0 0 1 .002 4.792l.353.354Zm-3.21 3.208 3.21-3.208-.353-.354-3.21 3.208.353.354Zm-.634.26c.23 0 .457-.086.633-.259l-.351-.356a.398.398 0 0 1-.282.116v.5Zm-.634-.26c.175.175.405.26.634.26v-.5a.395.395 0 0 1-.28-.114l-.354.354Zm0-1.266a.892.892 0 0 0 .001 1.267l.35-.356a.392.392 0 0 1 .002-.557l-.353-.354Zm3.208-3.208L11.634 9.33l.353.354 3.209-3.209-.354-.353Zm.617-1.484c0 .562-.219 1.087-.616 1.483l.352.355c.492-.49.764-1.143.764-1.838h-.5Zm-.617-1.484c.397.396.617.924.617 1.484h.5c0-.694-.274-1.348-.763-1.837l-.354.353Zm-2.97 0a2.105 2.105 0 0 1 2.97 0l.354-.353a2.605 2.605 0 0 0-3.678 0l.353.353ZM8.66 6.364l3.21-3.209-.353-.353-3.21 3.208.353.354Zm-1.267 0c.351.35.92.352 1.268-.002l-.356-.35a.393.393 0 0 1-.558-.002l-.354.354Zm0-1.266a.892.892 0 0 0 .002 1.267l.35-.356a.392.392 0 0 1 .002-.558l-.354-.353Zm3.21-3.209-3.21 3.209.354.353 3.21-3.208-.353-.354Zm-1.266 9.738-3.209 3.208.354.354L9.69 11.98l-.353-.353Zm1.267 0a.898.898 0 0 0-1.267 0l.352.354a.398.398 0 0 1 .563 0l.352-.355Zm0 1.266a.892.892 0 0 0 0-1.267l-.351.356c.153.151.155.4-.002.557l.354.354ZM7.395 16.1l3.212-3.207-.354-.354-3.212 3.207.354.354Zm-2.751 1.139c.995 0 1.995-.38 2.751-1.14l-.354-.352a3.373 3.373 0 0 1-2.397.992v.5Zm-2.751-1.14c.76.76 1.756 1.14 2.75 1.14v-.5c-.867 0-1.735-.331-2.397-.993l-.353.354ZM.75 13.35c0 1.037.405 2.017 1.142 2.75l.353-.354a3.356 3.356 0 0 1-.995-2.396h-.5Zm1.142-2.752A3.866 3.866 0 0 0 .75 13.35h.5c0-.905.352-1.755.995-2.398l-.353-.354Zm3.21-3.205-3.21 3.205.353.354 3.21-3.205-.353-.354Zm1.266 0a.893.893 0 0 0-1.267.002l.356.35a.393.393 0 0 1 .558.002l.353-.354Zm0 1.267a.892.892 0 0 0-.001-1.268l-.351.356c.154.152.155.401-.001.558l.353.354Zm-3.21 3.208 3.21-3.208-.353-.354-3.21 3.208.353.354Zm-.616 1.484c0-.562.218-1.088.616-1.484l-.353-.354a2.576 2.576 0 0 0-.763 1.838h.5Zm.618 1.484a2.091 2.091 0 0 1-.618-1.484h-.5c0 .694.275 1.346.764 1.837l.354-.353Zm1.484.615a2.079 2.079 0 0 1-1.484-.615l-.354.353c.49.492 1.143.762 1.838.762v-.5Zm1.485-.616a2.09 2.09 0 0 1-1.485.616v.5c.694 0 1.349-.273 1.839-.762l-.354-.354Z"
                          />
                        </svg>
                      }
                    </div>
                    <div className="ml-1">Block Time</div>
                    <div className="ml-1">
                      {!isLinked && (
                        <div className="ml-2">
                          {calculateCaseBlockTimeInMinutes(
                            new Date(blkStartYear, blkStartMonth, blkStartDate),
                            blockStartHour,
                            blockStartMinute,
                            new Date(blkEndYear, blkEndMonth, blkEndDate),
                            blockEndHour,
                            blockEndMinute
                          )}
                        </div>
                      )}
                      {isLinked && (
                        <div className="ml-2">
                          {calculateCaseBlockTimeInMinutes(
                            linkedStartDate,
                            linkedStartHour,
                            linkedStartMinute,
                            linkedEndDate,
                            linkedEndHour,
                            linkedEndMinute
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  {/* Start Date/Time Section */}
                  <div className="fx fx__v-center p-1">
                    {/* Icon */}
                    <div
                      className="fx fx__hv-center"
                      style={{ height: "24px", width: "24px" }}
                    >
                      {!isLinked && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="none"
                          // isBlockStartDatePristine ||
                          style={{
                            display: isBlkStartTimePristine ? "" : "none"
                          }}
                        >
                          <path
                            fill="#FF0"
                            fillRule="evenodd"
                            d="M16 0H0v16h16V0ZM1.17 14.328a1 1 0 0 1-.84-1.543l6.832-10.56a1 1 0 0 1 1.68 0l6.831 10.56a1 1 0 0 1-.84 1.543H1.17Zm7.827-1.863a.996.996 0 1 1-1.992 0 .996.996 0 0 1 1.992 0Zm-.996-1.875c.55 0 .996-.446.996-.996V5.609a.996.996 0 0 0-1.992 0v3.985c0 .55.446.996.996.996Z"
                            clipRule="evenodd"
                          />
                        </svg>
                      )}
                    </div>
                    <div className="ml-1" style={{ minWidth: "32px" }}>Start</div>
                    {/* Start Date */}
                    <div>
                      {isLinked
                        ? <div className="ml-2">{parseDateStringFromIsoDate(linkedStartDate)}</div>
                        : <DatePicker
                          zIndex="2600"
                          className="ml-2"
                          left={-50}
                          date={blkStartDate}
                          month={blkStartMonth}
                          year={blkStartYear}
                          isPrisitine={isBlockStartDatePristine}
                          color={isBlockStartDatePristine ? yellow[500] : blue[400]}
                          noUnderline
                          onChangeDate={(year, month, date) => {
                            setShowCaseBlockDrawerCloseWarning(true);
                            props.updateCaseBlockData({
                              isBlockStartDatePristine: false,
                              blockStartDate: date,
                              blockStartMonth: month,
                              blockStartYear: year
                            });
                          }}
                        />
                      }
                    </div>
                    <div className="ml-2 mr-2">@</div>
                    {/* Start Time */}
                    <div>
                      {isLinked
                        ? <div>
                          {`${padZero(linkedStartHour)}:${padZero(linkedStartMinute)}`}
                        </div>
                        : <TimePicker
                          className="pl-1 pr-2"
                          hour={blockStartHour}
                          minute={blockStartMinute}
                          color={isBlkStartTimePristine ? yellow[500] : blue[400]}
                          noUnderline
                          timeFormat="24H"
                          timePeriod="AM"
                          isPristine={isBlkStartTimePristine}
                          disableTimeFormat
                          onChangeTime={(hour, min) => {
                            debugLogToConsole('🚀🚀🚀 Block start time -- onChangeTime');
                            setShowCaseBlockDrawerCloseWarning(true);
                            setIsBlkStartTimePristine(false);
                            props.updateCaseBlockData({
                              blockStartHour: hour,
                              blockStartMinute: min,
                              isBlockStartTimePristine: false
                            });
                          }}
                        />
                      }
                    </div>
                  </div>
                  {/* Stop Date/Time Section */}
                  <div className="fx fx__v-center p-1">
                    {/* Icon */}
                    <div
                      style={{ height: "24px", width: "24px" }}
                      className="fx fx__hv-center"
                    >
                      {!isLinked && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="none"
                          style={{
                            display: showBlockTimeError ? "" : "none",
                          }}
                        >
                          <path
                            fill="#FF0"
                            fillRule="evenodd"
                            d="M16 0H0v16h16V0ZM1.17 14.328a1 1 0 0 1-.84-1.543l6.832-10.56a1 1 0 0 1 1.68 0l6.831 10.56a1 1 0 0 1-.84 1.543H1.17Zm7.827-1.863a.996.996 0 1 1-1.992 0 .996.996 0 0 1 1.992 0Zm-.996-1.875c.55 0 .996-.446.996-.996V5.609a.996.996 0 0 0-1.992 0v3.985c0 .55.446.996.996.996Z"
                            clipRule="evenodd"
                          />
                        </svg>
                      )}
                    </div>
                    <div className="ml-1" style={{ minWidth: "32px" }}>
                      Stop
                    </div>
                    {/* Stop Date */}
                    <div>
                      {isLinked
                        ? <div className="ml-2">{parseDateStringFromIsoDate(linkedEndDate)}</div>
                        : <DatePicker
                          zIndex="2600"
                          className="ml-2"
                          left={-50}
                          date={blkEndDate}
                          month={blkEndMonth}
                          year={blkEndYear}
                          isPrisitine={isBlockEndDatePristine}
                          color={
                            isBlockEndDatePristine ? yellow[500] : blue[400]
                          }
                          noUnderline
                          onChangeDate={(year, month, date) => {
                            setShowCaseBlockDrawerCloseWarning(true);
                            props.updateCaseBlockData({
                              isBlockStartDatePristine: false,
                              blockEndDate: date,
                              blockEndMonth: month,
                              blockEndYear: year
                            });
                          }}
                        />
                      }
                    </div>
                    <div className="ml-2 mr-2">@</div>
                    {/* Stop Time */}
                    <div>
                      {isLinked
                        ? <div>
                          {`${padZero(linkedEndHour)}:${padZero(linkedEndMinute)}`}
                        </div>
                        : <TimePicker
                          className="pl-1 pr-2"
                          hour={blockEndHour}
                          minute={blockEndMinute}
                          color={
                            isBlkEndTimePristine || showBlockTimeError
                              ? yellow[500]
                              : blue[400]
                          }
                          noUnderline
                          timeFormat="24H"
                          timePeriod="AM"
                          isPristine={isBlkEndTimePristine}
                          disableTimeFormat
                          onChangeTime={(hour, min) => {
                            debugLogToConsole('🚀🚀🚀 Block end time -- onChangeTime');
                            setShowCaseBlockDrawerCloseWarning(true);
                            setIsBlkEndTimePristine(false);
                            props.updateCaseBlockData({
                              blockEndHour: hour,
                              blockEndMinute: min,
                              isBlockEndTimePristine: false
                            });
                          }}
                        />
                      }
                    </div>
                  </div>
                </div>
              </div>
              {/* Content blockCases */}
              <div className={css(styles.sideDrawerContentArea)}>
                {markConcurrentCasesHandler(
                  props.caseBlockCaseSchedules.sort(ascendingSortCaseSchedulesByStart),
                ).map((el, idx) => {
                  return (
                    <div
                      className="mt-1"
                      key={el._id || Math.random().toString(36).slice(2)}
                    >
                      <CaseCard
                        key={`${el._id}__case_card`}
                        index={idx}
                        caseData={el}
                        isConcurrent={el.isConcurrent || false}
                        onEditCase={handleOnEditCase}
                        onMarkForDeletion={(caseId, index) => {
                          if (caseId) {
                            props.markCaseBlockCaseForDeletion(caseId);
                          } else {
                            props.unMarkCaseBlockCaseForCreation(index);
                          }
                        }}
                        onCancelDelete={(caseId) => {
                          props.unMarkCaseBlockCaseForDeletion(caseId);
                        }}
                        patientData={
                          el.patientId ? props.caseBlockPatients[el.patientId] : {}
                        }
                      />
                    </div>
                  );
                })}
              </div>
              {/* Footer */}
              <div className={css(styles.sideDrawerFooter)}>
                {/* Cancel Button */}
                <Button
                  btnType="primary"
                  isOutlineBtn
                  style={{
                    width: "90px",
                    height: "28px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                  onClick={handleOnCloseCaseBlockDrawer}
                >
                  Cancel
                </Button>
                {/* Create / Update Button */}
                <Button
                  btnType="primary"
                  className="ml-2"
                  isDisabled={!canCreateCaseBlock}
                  style={{
                    width: "140px",
                    height: "28px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                  onClick={() => {
                    const cbData = {};
                    const {
                      facilityId,
                      facilityName,
                      location,
                      surgeon,
                      anesthesiologist,
                      crna,
                      isNoneCrna,
                      isNoneAnesthesiologist,
                      isLinked = false,
                      blockStartDate,
                      blockStartHour,
                      blockStartMinute,
                      blockEndDate,
                      blockEndHour,
                      blockEndMinute,
                      linkedStartDate,
                      linkedStartHour,
                      linkedStartMinute,
                      linkedEndDate,
                      linkedEndHour,
                      linkedEndMinute,
                      _id
                    } = props.activeCaseBlock;

                    cbData._id = _id;
                    cbData.date = makeIsoDateString(scheduleYear, scheduleMonth, scheduleDate);
                    cbData.surgeon = surgeon;
                    cbData.crna = crna || {};
                    cbData.anesthesiologist = anesthesiologist || {};
                    // Here the checkbox works opposite  🢂 true is false and false is true
                    cbData.isNoneCrna = isNoneCrna;
                    cbData.isNoneAnesthesiologist = isNoneAnesthesiologist;
                    cbData.isLinked = isLinked;

                    if (isLinked) {
                      cbData.linkedStartDate = linkedStartDate;
                      cbData.linkedStartHour = linkedStartHour;
                      cbData.linkedStartMinute = linkedStartMinute;
                      cbData.linkedEndDate = linkedEndDate;
                      cbData.linkedEndHour = linkedEndHour;
                      cbData.linkedEndMinute = linkedEndMinute;
                    } else {
                      cbData.blockStartDate = new Date(Date.parse(blockStartDate));
                      cbData.blockStartHour = blockStartHour;
                      cbData.blockStartMinute = blockStartMinute;
                      cbData.blockEndDate = new Date(Date.parse(blockEndDate));
                      cbData.blockEndHour = blockEndHour;
                      cbData.blockEndMinute = blockEndMinute;
                    }

                    if (props.isEditingCaseBlock) {
                      // const newCaseSchedules = props.caseBlockCaseSchedules.filter(el => el.isNew);
                      const newCaseSchedules = props.caseBlockCaseSchedules.filter(el => !el.isMarkedForDeletion);
                      const casesToDeleteIds = [];
                      props.caseBlockCaseSchedules.forEach((el) => {
                        if (el.isMarkedForDeletion) {
                          casesToDeleteIds.push(el._id);
                        }
                      });
                      props.saveCaseBlock({
                        facilityData: { facilityId, facilityName, location },
                        casesToCreate: newCaseSchedules,
                        casesToDeleteIds: casesToDeleteIds || [],
                        blockData: cbData
                      });
                    } else {
                      const casesToCreate = clone(props.caseBlockCaseSchedules);
                      casesToCreate.forEach(el => delete el.tmpId);

                      props.createNewCaseBlock({
                        practiceNpi: props.selectedPractice.npi,
                        facilityData: { facilityId, facilityName, location },
                        // casesToCreate: props.caseBlockCaseSchedules,
                        casesToCreate,
                        blockData: cbData
                      });
                    }

                    scrollToStartHour();
                  }}
                >
                  {props.isEditingCaseBlock
                    ? "Update Case Block"
                    : "Create Case Block"}
                </Button>
              </div>
            </div>
          </Drawer>
        }

        {/* --- Director Blocks Drawer --- */}
        {showDirectorBlockDrawer && (
          <Drawer
            placement="right"
            visible={showDirectorBlockDrawer}
            toggleDrawer={handleOnCloseDirectorBlockDrawer}
            zIndex="2000"
            width={window.innerWidth <= 700 ? window.innerWidth : 375}
          >
            <div className={css(styles.sideDrawerContainer)}>
              {/* Header */}
              <div className={css(styles.sideDrawerHeader)}>
                {/* Top Row */}
                <div className={css(styles.sideDrawerHeaderTopRow)}>
                  {/* Left aligned -- Facility and location */}
                  <div className="fx fx__hv-center">
                    <div className="fx">
                      <div
                        className="text-truncate"
                        style={{ maxWidth: "180px" }}
                      >
                        {activeAssignment.facilityName || ""}
                      </div>
                      <div className="ml-2 mr-2">| Director</div>
                    </div>
                  </div>
                  {/* Right aligned icons */}
                  <div className="fx fx__v-center">
                    {/* Collapse */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="none"
                      className="ml-2"
                      onClick={handleOnCloseDirectorBlockDrawer}
                    >
                      <path
                        fill="#96C8FF"
                        fillRule="evenodd"
                        d="M2 0a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm8.92 9.464h3.587a.491.491 0 1 0 0-.983h-2.359l2.594-2.59a.49.49 0 1 0-.695-.693l-2.634 2.63V5.491a.491.491 0 0 0-.983 0v3.483a.49.49 0 0 0 .49.49Zm-5.43 2.05h2.36l-2.593 2.59a.49.49 0 1 0 .695.694l2.635-2.63v2.337a.491.491 0 0 0 .983 0v-3.483a.491.491 0 0 0-.491-.49H5.492a.491.491 0 0 0-.001.982Z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                </div>
                {/* ___ Director Section ___ */}
                <div className={css(styles.sideDrawerHeaderRow)}>
                  {/* Title */}
                  <div className={css(styles.sideDrawerHeaderRowTitle)}>
                    Director
                  </div>
                  {/* Case Block Surgeon */}
                  <div
                    className="ml-2"
                    style={{ color: blue[400], position: "relative" }}
                    ref={dirMenuRef}
                  >
                    {Object.keys(selectedDirector).length > 0
                      ? `${selectedDirector.lastName}, ${selectedDirector.firstName} ${selectedDirector.credentials}`
                      : "? Select"}
                    <i
                      className="fa fa-chevron-down ml-1"
                      onClick={() => {
                        setDirectorSearch("");
                        setIsDirectorSearchPristine(true);
                        setDirectors([]);
                        setShowDirMenu(!showDirMenu);
                      }}
                    />
                    <PopupMenu
                      top={1}
                      left={1}
                      position="absolute"
                      zIndex="3000"
                      visible={showDirMenu}
                      parent={dirMenuRef}
                      onOutsideClick={() => {
                        setShowDirMenu(false);
                      }}
                    >
                      <div className={css(styles.gridEllipsisMenuContainer)}>
                        {/* Director search textbox */}
                        <div className="pl-2 pt-1">
                          <TextInput
                            placeholder="Search Director"
                            value={directorSearch}
                            onChange={handleOnChangeDirectorSearch}
                            style={{
                              width: "204px",
                              height: "20px",
                              background: "#103a60",
                              border: "1px solid #60A0E0",
                              borderWidth: "0 0 1px 0",
                              marginBottom: "2px",
                              fontSize: "12px",
                              fontWeight: "700",
                            }}
                          />
                        </div>
                        {directors.length === 0 && isDirectorSearchPristine && (
                          <div
                            style={{
                              fontSize: "14px",
                              padding: "8px",
                              color: gray[300],
                            }}
                          >
                            Type director name in the text box above to search
                          </div>
                        )}
                        {directors.length === 0 &&
                          !isDirectorSearchPristine &&
                          directorSearch.length === 0 && (
                            <div
                              style={{
                                fontSize: "14px",
                                padding: "8px",
                                color: gray[300],
                              }}
                            >
                              Type director name in the text box above to search
                            </div>
                        )}
                        {directors.length === 0 &&
                          !isDirectorSearchPristine &&
                          directorSearch.length > 0 && (
                            <div
                              style={{
                                fontSize: "14px",
                                padding: "8px",
                                color: gray[300],
                              }}
                            >
                              No results found
                            </div>
                        )}
                        {directors.map((director) => {
                          return (
                            <div
                              key={`${director.npi}__director`}
                              className={css(styles.gridEllipsisMenuItem)}
                              onClick={() => {
                                setSelectedDirector(director);
                                setShowDirMenu(!showDirMenu);
                              }}
                            >
                              {`${director.lastName}, ${director.firstName} ${director.credentials}`}
                            </div>
                          );
                        })}
                      </div>
                    </PopupMenu>
                  </div>
                </div>
                {/* ___ Director Block Start Date and Time ___ */}
                <div className={css(styles.sideDrawerHeaderRow)}>
                  <div className={css(styles.sideDrawerHeaderRowTitle)}>
                    Start
                  </div>
                  <DatePicker
                    className="ml-2"
                    left={-10}
                    date={dirBlockStartDate}
                    month={dirBlockStartMonth}
                    year={dirBlockStartYear}
                    isPrisitine={isDirBlockStartDatePristine}
                    color={
                      isDirBlockStartDatePristine ? yellow[500] : blue[400]
                    }
                    noUnderline
                    onChangeDate={(year, month, date) => {
                      setDirBlockStartDate(date);
                      setDirBlockStartMonth(month);
                      setDirBlockStartYear(year);
                      setIsDirBlockStartDatePristine(false);
                    }}
                  />
                  <TimePicker
                    className="ml-2 pl-1 pr-2"
                    hour={dirBlockStartHour}
                    minute={dirBlockStartMinute}
                    color={
                      isDirBlockStartTimePristine ? yellow[500] : blue[500]
                    }
                    noUnderline
                    timeFormat="24H"
                    timePeriod="AM"
                    isPristine={isDirBlockStartTimePristine}
                    onChangeTime={(hour, min) => {
                      setIsDirBlockStartTimePristine(false);
                      setDirBlockStartHour(hour);
                      setDirBlockStartMinute(min);
                    }}
                    disableTimeFormat
                  />
                </div>
                {/* ___ Director Block Stop Date and Time ___ */}
                <div className={css(styles.sideDrawerHeaderRow)}>
                  <div className={css(styles.sideDrawerHeaderRowTitle)}>
                    Stop
                  </div>
                  <DatePicker
                    className="ml-2"
                    left={-10}
                    date={dirBlockStopDate}
                    month={dirBlockStopMonth}
                    year={dirBlockStopYear}
                    isPrisitine={isDirBlockStopDatePristine}
                    color={isDirBlockStopDatePristine ? yellow[500] : blue[400]}
                    noUnderline
                    onChangeDate={(year, month, date) => {
                      setDirBlockStopDate(date);
                      setDirBlockStopMonth(month);
                      setDirBlockStopYear(year);
                      setIsDirBlockStopDatePristine(false);
                    }}
                  />
                  <TimePicker
                    className="ml-2 pl-1 pr-2"
                    hour={dirBlockStopHour}
                    minute={dirBlockStopMinute}
                    color={isDirBlockStopTimePristine ? yellow[500] : blue[500]}
                    noUnderline
                    timeFormat="24H"
                    timePeriod="AM"
                    isPristine={isDirBlockStopTimePristine}
                    onChangeTime={(hour, min) => {
                      setIsDirBlockStopTimePristine(false);
                      setDirBlockStopHour(hour);
                      setDirBlockStopMinute(min);
                    }}
                    disableTimeFormat
                  />
                </div>
                {/* Repeat Assignments */}
                <div
                  style={{ position: "relative" }}
                  className={`mb-2 ${css(styles.sideDrawerHeaderRow)}`}
                >
                  <div className={css(styles.sideDrawerHeaderRowTitle)}>
                    Repeat
                  </div>
                  <div
                    className="ml-2"
                    ref={dirBlockRepeatMenuRef}
                    onClick={() => setShowDirBlockRepeatMenu(true)}
                  >
                    {titleCase(dirBlockRepeatFrequency) === "None" && "Never"}
                    {titleCase(dirBlockRepeatFrequency) === "Week" &&
                      "Every Week"}
                    {titleCase(dirBlockRepeatFrequency) === "Month" &&
                      "Every Month"}
                    {titleCase(dirBlockRepeatFrequency) === "Year" &&
                      "Every Year"}
                    <i className="fa fa-chevron-down ml-2" />
                  </div>
                  <PopupMenu
                    top={20}
                    left={53}
                    position="absolute"
                    zIndex="2501"
                    visible={showDirBlockRepeatMenu}
                    parent={dirBlockRepeatMenuRef}
                    onOutsideClick={() => {
                      setShowDirBlockRepeatMenu(false);
                    }}
                  >
                    <div
                      style={{
                        width: "120px",
                        height: "64px",
                        minHeight: "64px",
                      }}
                      className={css(styles.gridEllipsisMenuContainer)}
                    >
                      {/* Every Week */}
                      <div
                        className={css(
                          styles.gridEllipsisMenuItem,
                          dirBlockRepeatFrequency.toLowerCase() === "week" &&
                          styles.gridEllipsisMenuItemActive,
                        )}
                        onClick={() => {
                          setDirBlockRepeatFrequency("week");
                          setShowDirBlockRepeatMenu(false);
                        }}
                      >
                        Every Week
                      </div>
                      {/* Every Month */}
                      <div
                        className={css(
                          styles.gridEllipsisMenuItem,
                          dirBlockRepeatFrequency.toLowerCase() === "month" &&
                          styles.gridEllipsisMenuItemActive,
                        )}
                        onClick={() => {
                          setDirBlockRepeatFrequency("month");
                          setShowDirBlockRepeatMenu(false);
                        }}
                      >
                        Every Month
                      </div>
                      {/* Every Year */}
                      <div
                        className={css(
                          styles.gridEllipsisMenuItem,
                          dirBlockRepeatFrequency.toLowerCase() === "year" &&
                          styles.gridEllipsisMenuItemActive,
                        )}
                        onClick={() => {
                          setDirBlockRepeatFrequency("year");
                          setShowDirBlockRepeatMenu(false);
                        }}
                      >
                        Every Year
                      </div>
                    </div>
                  </PopupMenu>
                </div>
              </div>
              {/* Content */}
              <div className={css(styles.sideDrawerContentArea)} />
              {/* Footer */}
              <div className={css(styles.sideDrawerFooter)}>
                {/* Cancel Button */}
                <Button
                  btnType="primary"
                  isOutlineBtn
                  style={{
                    width: "90px",
                    height: "28px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                  onClick={handleOnCloseDirectorBlockDrawer}
                >
                  Cancel
                </Button>
                {/* Add Button */}
                <Button
                  btnType="primary"
                  className="ml-2"
                  style={{
                    width: "90px",
                    height: "28px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                  onClick={handleOnClickAddDirectorBlock}
                >
                  Add
                </Button>
              </div>
            </div>
          </Drawer>
        )}

        {/* --- Shift Blocks Drawer --- */}
        {showShiftBlockDrawer && (
          <Drawer
            placement="right"
            visible={showShiftBlockDrawer}
            toggleDrawer={handleOnCloseShiftBlockDrawer}
            zIndex="2000"
            width={window.innerWidth <= 700 ? window.innerWidth : 375}
          >
            <div className={css(styles.sideDrawerContainer)}>
              {/* Header */}
              <div className={css(styles.sideDrawerHeader)}>
                {/* Top Row */}
                <div className={css(styles.sideDrawerHeaderTopRow)}>
                  {/* Left aligned -- Facility and location */}
                  <div className="fx fx__hv-center">
                    <div className="fx">
                      <div
                        className="text-truncate"
                        style={{ maxWidth: "180px" }}
                      >
                        {activeAssignment.facilityName || ""}
                      </div>
                      <div className="ml-2 mr-2">| Shift Provider</div>
                    </div>
                  </div>
                  {/* Right aligned icons */}
                  <div className="fx fx__v-center">
                    {/* Collapse */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="none"
                      className="ml-2"
                      onClick={handleOnCloseShiftBlockDrawer}
                    >
                      <path
                        fill="#96C8FF"
                        fillRule="evenodd"
                        d="M2 0a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm8.92 9.464h3.587a.491.491 0 1 0 0-.983h-2.359l2.594-2.59a.49.49 0 1 0-.695-.693l-2.634 2.63V5.491a.491.491 0 0 0-.983 0v3.483a.49.49 0 0 0 .49.49Zm-5.43 2.05h2.36l-2.593 2.59a.49.49 0 1 0 .695.694l2.635-2.63v2.337a.491.491 0 0 0 .983 0v-3.483a.491.491 0 0 0-.491-.49H5.492a.491.491 0 0 0-.001.982Z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                </div>
                {/* ___ Provider Section ___ */}
                <div className={css(styles.sideDrawerHeaderRow)}>
                  {/* Title */}
                  <div className={css(styles.sideDrawerHeaderRowTitle)}>
                    Provider
                  </div>
                  {/* Selected Shift Block Provider */}
                  <div
                    className="ml-2"
                    style={{ color: blue[400], position: "relative" }}
                    ref={shiftMenuRef}
                  >
                    {Object.keys(selectedShiftProvider).length > 0
                      ? `${selectedShiftProvider.lastName}, ${selectedShiftProvider.firstName} ${selectedShiftProvider.credentials}`
                      : "? Select"}
                    <i
                      className="fa fa-chevron-down ml-1"
                      onClick={() => {
                        setShiftSearch("");
                        setIsShiftSearchPristine(true);
                        setShiftProviders([]);
                        setShowShiftMenu(!showShiftMenu);
                      }}
                    />
                    <PopupMenu
                      top={1}
                      left={1}
                      position="absolute"
                      zIndex="3000"
                      visible={showShiftMenu}
                      parent={shiftMenuRef}
                      onOutsideClick={() => {
                        setShowShiftMenu(false);
                      }}
                    >
                      <div className={css(styles.gridEllipsisMenuContainer)}>
                        {/* Director search textbox */}
                        <div className="pl-2 pt-1">
                          <TextInput
                            placeholder="Search Provider"
                            value={shiftSearch}
                            onChange={handleOnChangeShiftProviderSearch}
                            style={{
                              width: "204px",
                              height: "20px",
                              background: "#103a60",
                              border: "1px solid #60A0E0",
                              borderWidth: "0 0 1px 0",
                              marginBottom: "2px",
                              fontSize: "12px",
                              fontWeight: "700",
                            }}
                          />
                        </div>
                        {shiftProviders.length === 0 &&
                          isShiftSearchPristine && (
                            <div
                              style={{
                                fontSize: "14px",
                                padding: "8px",
                                color: gray[300],
                              }}
                            >
                              Type provider name in the text box above to search
                            </div>
                        )}
                        {shiftProviders.length === 0 &&
                          !isShiftSearchPristine &&
                          shiftSearch.length === 0 && (
                            <div
                              style={{
                                fontSize: "14px",
                                padding: "8px",
                                color: gray[300],
                              }}
                            >
                              Type provider name in the text box above to search
                            </div>
                        )}
                        {shiftProviders.length === 0 &&
                          !isShiftSearchPristine &&
                          shiftSearch.length > 0 && (
                            <div
                              style={{
                                fontSize: "14px",
                                padding: "8px",
                                color: gray[300],
                              }}
                            >
                              No results found
                            </div>
                        )}
                        {shiftProviders.map((sp) => {
                          return (
                            <div
                              key={`${sp.npi}__sp`}
                              className={css(styles.gridEllipsisMenuItem)}
                              onClick={() => {
                                setSelectedShiftProvider(sp);
                                setShowShiftMenu(!showShiftMenu);
                              }}
                            >
                              {`${sp.lastName}, ${sp.firstName} ${sp.credentials}`}
                            </div>
                          );
                        })}
                      </div>
                    </PopupMenu>
                  </div>
                </div>
                {/* ___ Shift Block Start Date and Time ___ */}
                <div className={css(styles.sideDrawerHeaderRow)}>
                  <div className={css(styles.sideDrawerHeaderRowTitle)}>
                    Start
                  </div>
                  <DatePicker
                    className="ml-2"
                    left={-10}
                    date={shiftBlockStartDate}
                    month={shiftBlockStartMonth}
                    year={shiftBlockStartYear}
                    isPrisitine={isShiftBlockStartDatePristine}
                    color={
                      isShiftBlockStartDatePristine ? yellow[500] : blue[400]
                    }
                    noUnderline
                    onChangeDate={(year, month, date) => {
                      setShiftBlockStartDate(date);
                      setShiftBlockStartMonth(month);
                      setShiftBlockStartYear(year);
                      setIsShiftBlockStartDatePristine(false);
                    }}
                  />
                  <TimePicker
                    className="ml-2 pl-1 pr-2"
                    hour={shiftBlockStartHour}
                    minute={shiftBlockStartMinute}
                    color={
                      isShiftBlockStartTimePristine ? yellow[500] : blue[500]
                    }
                    noUnderline
                    timeFormat="24H"
                    timePeriod="AM"
                    isPristine={isShiftBlockStartTimePristine}
                    onChangeTime={(hour, min) => {
                      setIsShiftBlockStartTimePristine(false);
                      setShiftBlockStartHour(hour);
                      setShiftBlockStartMinute(min);
                    }}
                    disableTimeFormat
                  />
                </div>
                {/* ___ Shift Block Stop Date and Time ___ */}
                <div className={css(styles.sideDrawerHeaderRow)}>
                  <div className={css(styles.sideDrawerHeaderRowTitle)}>
                    Stop
                  </div>
                  <DatePicker
                    className="ml-2"
                    left={-10}
                    date={shiftBlockStopDate}
                    month={shiftBlockStopMonth}
                    year={shiftBlockStopYear}
                    isPrisitine={isShiftBlockStopDatePristine}
                    color={
                      isShiftBlockStopDatePristine ? yellow[500] : blue[400]
                    }
                    noUnderline
                    onChangeDate={(year, month, date) => {
                      setShiftBlockStopDate(date);
                      setShiftBlockStopMonth(month);
                      setShiftBlockStopYear(year);
                      setIsShiftBlockStopDatePristine(false);
                    }}
                  />
                  <TimePicker
                    className="ml-2 pl-1 pr-2"
                    hour={shiftBlockStopHour}
                    minute={shiftBlockStopMinute}
                    color={
                      isShiftBlockStopTimePristine ? yellow[500] : blue[500]
                    }
                    noUnderline
                    timeFormat="24H"
                    timePeriod="AM"
                    isPristine={isShiftBlockStopTimePristine}
                    onChangeTime={(hour, min) => {
                      setIsShiftBlockStopTimePristine(false);
                      setShiftBlockStopHour(hour);
                      setShiftBlockStopMinute(min);
                    }}
                    disableTimeFormat
                  />
                </div>
                {/* Repeat Assignments */}
                <div
                  style={{ position: "relative" }}
                  className={`mb-2 ${css(styles.sideDrawerHeaderRow)}`}
                >
                  <div className={css(styles.sideDrawerHeaderRowTitle)}>
                    Repeat
                  </div>
                  <div
                    className="ml-2"
                    ref={shiftBlockRepeatMenuRef}
                    onClick={() => setShowShiftBlockRepeatMenu(true)}
                  >
                    {titleCase(shiftBlockRepeatFrequency) === "None" && "Never"}
                    {titleCase(shiftBlockRepeatFrequency) === "Week" &&
                      "Every Week"}
                    {titleCase(shiftBlockRepeatFrequency) === "Month" &&
                      "Every Month"}
                    {titleCase(shiftBlockRepeatFrequency) === "Year" &&
                      "Every Year"}
                    <i className="fa fa-chevron-down ml-2" />
                  </div>
                  <PopupMenu
                    top={20}
                    left={53}
                    position="absolute"
                    zIndex="2501"
                    visible={showShiftBlockRepeatMenu}
                    parent={shiftBlockRepeatMenuRef}
                    onOutsideClick={() => {
                      setShowShiftBlockRepeatMenu(false);
                    }}
                  >
                    <div
                      style={{
                        width: "120px",
                        height: "64px",
                        minHeight: "64px",
                      }}
                      className={css(styles.gridEllipsisMenuContainer)}
                    >
                      {/* Every Week */}
                      <div
                        className={css(
                          styles.gridEllipsisMenuItem,
                          dirBlockRepeatFrequency.toLowerCase() === "week" &&
                          styles.gridEllipsisMenuItemActive,
                        )}
                        onClick={() => {
                          setShiftBlockRepeatFrequency("week");
                          setShowShiftBlockRepeatMenu(false);
                        }}
                      >
                        Every Week
                      </div>
                      {/* Every Month */}
                      <div
                        className={css(
                          styles.gridEllipsisMenuItem,
                          dirBlockRepeatFrequency.toLowerCase() === "month" &&
                          styles.gridEllipsisMenuItemActive,
                        )}
                        onClick={() => {
                          setShiftBlockRepeatFrequency("month");
                          setShowShiftBlockRepeatMenu(false);
                        }}
                      >
                        Every Month
                      </div>
                      {/* Every Year */}
                      <div
                        className={css(
                          styles.gridEllipsisMenuItem,
                          dirBlockRepeatFrequency.toLowerCase() === "year" &&
                          styles.gridEllipsisMenuItemActive,
                        )}
                        onClick={() => {
                          setShiftBlockRepeatFrequency("year");
                          setShowShiftBlockRepeatMenu(false);
                        }}
                      >
                        Every Year
                      </div>
                    </div>
                  </PopupMenu>
                </div>
              </div>
              {/* Content */}
              <div className={css(styles.sideDrawerContentArea)} />
              {/* Footer */}
              <div className={css(styles.sideDrawerFooter)}>
                {/* Cancel Button */}
                <Button
                  btnType="primary"
                  isOutlineBtn
                  style={{
                    width: "90px",
                    height: "28px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                  onClick={() => setShowShiftBlockDrawer(false)}
                >
                  Cancel
                </Button>
                {/* Add Button */}
                <Button
                  btnType="primary"
                  className="ml-2"
                  style={{
                    width: "90px",
                    height: "28px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                  onClick={handleOnClickAddShiftBlock}
                >
                  Add
                </Button>
              </div>
            </div>
          </Drawer>
        )}

        {/* --- Call Blocks Drawer --- */}
        {showCallBlockDrawer && (
          <Drawer
            placement="right"
            visible={showCallBlockDrawer}
            toggleDrawer={handleOnCloseCallBlockDrawer}
            zIndex="2000"
            width={window.innerWidth <= 700 ? window.innerWidth : 375}
          >
            <div className={css(styles.sideDrawerContainer)}>
              {/* Header */}
              <div className={css(styles.sideDrawerHeader)}>
                {/* Top Row */}
                <div className={css(styles.sideDrawerHeaderTopRow)}>
                  {/* Left aligned -- Facility and location */}
                  <div className="fx fx__hv-center">
                    <div className="fx">
                      <div
                        className="text-truncate"
                        style={{ maxWidth: "180px" }}
                      >
                        {activeAssignment.facilityName || ""}
                      </div>
                      <div className="ml-2 mr-2">| Call Provider</div>
                    </div>
                  </div>
                  {/* Right aligned icons */}
                  <div className="fx fx__v-center">
                    {/* Collapse */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="none"
                      className="ml-2"
                      onClick={handleOnCloseCallBlockDrawer}
                    >
                      <path
                        fill="#96C8FF"
                        fillRule="evenodd"
                        d="M2 0a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm8.92 9.464h3.587a.491.491 0 1 0 0-.983h-2.359l2.594-2.59a.49.49 0 1 0-.695-.693l-2.634 2.63V5.491a.491.491 0 0 0-.983 0v3.483a.49.49 0 0 0 .49.49Zm-5.43 2.05h2.36l-2.593 2.59a.49.49 0 1 0 .695.694l2.635-2.63v2.337a.491.491 0 0 0 .983 0v-3.483a.491.491 0 0 0-.491-.49H5.492a.491.491 0 0 0-.001.982Z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                </div>
                {/* ___ Provider Section ___ */}
                <div className={css(styles.sideDrawerHeaderRow)}>
                  {/* Title */}
                  <div className={css(styles.sideDrawerHeaderRowTitle)}>
                    Provider
                  </div>
                  {/* Selected Shift Block Provider */}
                  <div
                    className="ml-2"
                    style={{ color: blue[400], position: "relative" }}
                    ref={callMenuRef}
                  >
                    {Object.keys(selectedCallProvider).length > 0
                      ? `${selectedCallProvider.lastName}, ${selectedCallProvider.firstName} ${selectedCallProvider.credentials}`
                      : "? Select"}
                    <i
                      className="fa fa-chevron-down ml-1"
                      onClick={() => {
                        setCallSearch("");
                        setIsCallSearchPristine(true);
                        setCallProviders([]);
                        setShowCallMenu(!showCallMenu);
                      }}
                    />
                    <PopupMenu
                      top={1}
                      left={1}
                      position="absolute"
                      zIndex="3000"
                      visible={showCallMenu}
                      parent={callMenuRef}
                      onOutsideClick={() => {
                        setShowCallMenu(false);
                      }}
                    >
                      <div className={css(styles.gridEllipsisMenuContainer)}>
                        {/* Director search textbox */}
                        <div className="pl-2 pt-1">
                          <TextInput
                            placeholder="Search Provider"
                            value={callSearch}
                            onChange={handleOnChangeCallProviderSearch}
                            style={{
                              width: "204px",
                              height: "20px",
                              background: "#103a60",
                              border: "1px solid #60A0E0",
                              borderWidth: "0 0 1px 0",
                              marginBottom: "2px",
                              fontSize: "12px",
                              fontWeight: "700",
                            }}
                          />
                        </div>
                        {callProviders.length === 0 && isCallSearchPristine && (
                          <div
                            style={{
                              fontSize: "14px",
                              padding: "8px",
                              color: gray[300],
                            }}
                          >
                            Type provider name in the text box above to search
                          </div>
                        )}
                        {callProviders.length === 0 &&
                          !isCallSearchPristine &&
                          callSearch.length === 0 && (
                            <div
                              style={{
                                fontSize: "14px",
                                padding: "8px",
                                color: gray[300],
                              }}
                            >
                              Type provider name in the text box above to search
                            </div>
                        )}
                        {callProviders.length === 0 &&
                          !isCallSearchPristine &&
                          callSearch.length > 0 && (
                            <div
                              style={{
                                fontSize: "14px",
                                padding: "8px",
                                color: gray[300],
                              }}
                            >
                              No results found
                            </div>
                        )}
                        {callProviders.map((cp) => {
                          return (
                            <div
                              key={`${cp.npi}__cp`}
                              className={css(styles.gridEllipsisMenuItem)}
                              onClick={() => {
                                setSelectedCallProvider(cp);
                                setShowCallMenu(!showCallMenu);
                              }}
                            >
                              {`${cp.lastName}, ${cp.firstName} ${cp.credentials}`}
                            </div>
                          );
                        })}
                      </div>
                    </PopupMenu>
                  </div>
                </div>
                {/* ___ Call Block Start Date and Time ___ */}
                <div className={css(styles.sideDrawerHeaderRow)}>
                  <div className={css(styles.sideDrawerHeaderRowTitle)}>
                    Start
                  </div>
                  <DatePicker
                    className="ml-2"
                    left={-10}
                    date={callBlockStartDate}
                    month={callBlockStartMonth}
                    year={callBlockStartYear}
                    isPrisitine={isCallBlockStartDatePristine}
                    color={
                      isCallBlockStartDatePristine ? yellow[500] : blue[400]
                    }
                    noUnderline
                    onChangeDate={(year, month, date) => {
                      setCallBlockStartDate(date);
                      setCallBlockStartMonth(month);
                      setCallBlockStartYear(year);
                      setIsCallBlockStartDatePristine(false);
                    }}
                  />
                  <TimePicker
                    className="ml-2 pl-1 pr-2"
                    hour={callBlockStartHour}
                    minute={callBlockStartMinute}
                    color={
                      isCallBlockStartTimePristine ? yellow[500] : blue[500]
                    }
                    noUnderline
                    timeFormat="24H"
                    timePeriod="AM"
                    isPristine={isCallBlockStartTimePristine}
                    onChangeTime={(hour, min) => {
                      setIsCallBlockStartTimePristine(false);
                      setCallBlockStartHour(hour);
                      setCallBlockStartMinute(min);
                    }}
                    disableTimeFormat
                  />
                </div>
                {/* ___ Call Block Stop Date and Time ___ */}
                <div className={css(styles.sideDrawerHeaderRow)}>
                  <div className={css(styles.sideDrawerHeaderRowTitle)}>
                    Stop
                  </div>
                  <DatePicker
                    className="ml-2"
                    left={-10}
                    date={callBlockStopDate}
                    month={callBlockStopMonth}
                    year={callBlockStopYear}
                    isPrisitine={isCallBlockStopDatePristine}
                    color={
                      isCallBlockStopDatePristine ? yellow[500] : blue[400]
                    }
                    noUnderline
                    onChangeDate={(year, month, date) => {
                      setCallBlockStopDate(date);
                      setCallBlockStopMonth(month);
                      setCallBlockStopYear(year);
                      setIsCallBlockStopDatePristine(false);
                    }}
                  />
                  <TimePicker
                    className="ml-2 pl-1 pr-2"
                    hour={callBlockStopHour}
                    minute={callBlockStopMinute}
                    color={
                      isCallBlockStopTimePristine ? yellow[500] : blue[500]
                    }
                    noUnderline
                    timeFormat="24H"
                    timePeriod="AM"
                    isPristine={isCallBlockStopTimePristine}
                    onChangeTime={(hour, min) => {
                      setIsCallBlockStopTimePristine(false);
                      setCallBlockStopHour(hour);
                      setCallBlockStopMinute(min);
                    }}
                    disableTimeFormat
                  />
                </div>
                {/* Repeat Assignments */}
                <div
                  style={{ position: "relative" }}
                  className={`mb-2 ${css(styles.sideDrawerHeaderRow)}`}
                >
                  <div className={css(styles.sideDrawerHeaderRowTitle)}>
                    Repeat
                  </div>
                  <div
                    className="ml-2"
                    ref={callBlockRepeatMenuRef}
                    onClick={() => setShowCallBlockRepeatMenu(true)}
                  >
                    {titleCase(callBlockRepeatFrequency) === "None" && "Never"}
                    {titleCase(callBlockRepeatFrequency) === "Week" &&
                      "Every Week"}
                    {titleCase(callBlockRepeatFrequency) === "Month" &&
                      "Every Month"}
                    {titleCase(callBlockRepeatFrequency) === "Year" &&
                      "Every Year"}
                    <i className="fa fa-chevron-down ml-2" />
                  </div>
                  <PopupMenu
                    top={20}
                    left={53}
                    position="absolute"
                    zIndex="2501"
                    visible={showCallBlockRepeatMenu}
                    parent={callBlockRepeatMenuRef}
                    onOutsideClick={() => {
                      setShowCallBlockRepeatMenu(false);
                    }}
                  >
                    <div
                      style={{
                        width: "120px",
                        height: "64px",
                        minHeight: "64px",
                      }}
                      className={css(styles.gridEllipsisMenuContainer)}
                    >
                      {/* Every Week */}
                      <div
                        className={css(
                          styles.gridEllipsisMenuItem,
                          callBlockRepeatFrequency.toLowerCase() === "week" &&
                          styles.gridEllipsisMenuItemActive,
                        )}
                        onClick={() => {
                          setCallBlockRepeatFrequency("week");
                          setShowCallBlockRepeatMenu(false);
                        }}
                      >
                        Every Week
                      </div>
                      {/* Every Month */}
                      <div
                        className={css(
                          styles.gridEllipsisMenuItem,
                          callBlockRepeatFrequency.toLowerCase() === "month" &&
                          styles.gridEllipsisMenuItemActive,
                        )}
                        onClick={() => {
                          setCallBlockRepeatFrequency("month");
                          setShowCallBlockRepeatMenu(false);
                        }}
                      >
                        Every Month
                      </div>
                      {/* Every Year */}
                      <div
                        className={css(
                          styles.gridEllipsisMenuItem,
                          callBlockRepeatFrequency.toLowerCase() === "year" &&
                          styles.gridEllipsisMenuItemActive,
                        )}
                        onClick={() => {
                          setCallBlockRepeatFrequency("year");
                          setShowCallBlockRepeatMenu(false);
                        }}
                      >
                        Every Year
                      </div>
                    </div>
                  </PopupMenu>
                </div>
              </div>
              {/* Content */}
              <div className={css(styles.sideDrawerContentArea)} />
              {/* Footer */}
              <div className={css(styles.sideDrawerFooter)}>
                {/* Cancel Button */}
                <Button
                  btnType="primary"
                  isOutlineBtn
                  style={{
                    width: "90px",
                    height: "28px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                  onClick={() => setShowShiftBlockDrawer(false)}
                >
                  Cancel
                </Button>
                {/* Add Button */}
                <Button
                  btnType="primary"
                  className="ml-2"
                  style={{
                    width: "90px",
                    height: "28px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                  onClick={handleOnClickAddCallBlock}
                >
                  Add
                </Button>
              </div>
            </div>
          </Drawer>
        )}

        {/* Schedule Case Drawer */}
        {props.showScheduleCaseDrawer && (
          <ScheduleCaseDrawer2
            forCaseBlocks
            caseBlockId={caseBlockId}
            facilityData={{
              facilityId: activeLocation.facilityId,
              facilityName: activeLocation.facilityName,
              location: activeLocation.location,
            }}
            initialData={initialCaseData}
            onMarkCaseForCreation={handleOnMarkCaseForCreation}
            onClose={() => props.toggleScheduleCaseDrawer(false)}
          />
        )}
        {/* Case Dashboard */}
        {props.showCbCaseScheduleDashboard && (
          <CbScheduleDashboard
            forCaseBlocks
            caseData={props.caseBlockActiveCaseSchedule}
            patientData={
              props.caseBlockActiveCaseSchedule && props.caseBlockActiveCaseSchedule.patientId
                ? props.caseBlockPatients[props.caseBlockActiveCaseSchedule.patientId]
                : {}
            }
            onMarkCaseForUpdate={handleOnMarkCaseForUpdate}
            onClose={handleOnCloseCbScheduleDashboard}
          />
        )}
        {/* BG Color Picker */}
        {showBgColorPicker &&
          <DialogBox
            showCloseBtn={false}
            initWidth={DIALOG_WIDTH}
            top={window.innerWidth <= 576 ? 48 : null}
            left={window.innerWidth <= 576 ? 8 : null}
            initHeight={265}
            isOpen={showBgColorPicker}
            onClose={() => {
              setShowBgColorPicker(false);
            }}
            showMask={false}
            closeOnEscKey
            closeOnMaskClick={false}
            header={{
              overrideTheme: true,
              text: 'Select Colors For Facility Location',
              backColor: '#082840',
              closeColor: '#FF6060',
              fontStyle: 'bold',
              fontSize: '14px',
              icon: ''
            }}
          >
            <div className='p-2'>
              <div className='p-2'>
                <div className='fx'>
                  <div className={css(styles.cpTtitle)}>Background Color</div>
                  <input
                    type='color'
                    value={bgColor}
                    onChange={(e) => {
                      const { value } = e.target;
                      setBgColor(value);
                    }}
                  />
                </div>
                <div className='fx mt-2'>
                  <div className={css(styles.cpTtitle)}>Text Color</div>
                  <input
                    type='color'
                    value={fgColor}
                    onChange={(e) => {
                      const { value } = e.target;
                      setFgColor(value);
                    }}
                  />
                </div>
              </div>
              <div
                className='fx mt-4'
                style={{
                  justifyContent: 'flex-end'
                }}
              >
                {/* Save Button */}
                <Button
                  btnType='primary'
                  style={{
                    width: '80px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white'
                  }}
                  onClick={() => {
                    props.saveFacilityColors(bgColor, fgColor, props.selectedPractice._id, selectedFacilityId);
                    setShowBgColorPicker(false);
                  }}
                >
                  Save
                </Button>
                {/* Cancel Button */}
                <Button
                  className='ml-2'
                  btnType='primary'
                  isOutlineBtn
                  style={{
                    border: `1px solid ${gray[400]}`,
                    color: gray[300],
                    width: '80px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  onClick={() => setShowBgColorPicker(false)}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </DialogBox>
        }
        {/* Grid Container */}
        <div className={css(styles.gridContainer)}>
          {/* Header */}
          <div className={css(styles.header)}>
            {/* Left Pinned */}
            <div className={css(styles.leftHeader)}>
              <div className={css(styles.leftHeaderTitle)}>
                Facilities/Rooms
              </div>
              <div>
                <TextInput
                  placeholder="Search Facilities"
                  placeholderColor="yellow"
                  value={facilitySearch}
                  showClearFieldIcon
                  onChange={handleOnFacilitySearchValueChanged}
                  style={{
                    width: "150px",
                    height: "20px",
                    background: "#103a60",
                    border: "1px solid #60A0E0",
                    borderWidth: "0 0 1px 0",
                    marginBottom: "2px",
                    fontSize: "12px",
                    fontWeight: "700",
                  }}
                />
              </div>
            </div>
            {/* Center (All others) headers */}
            <div className={css(styles.centerHeader)}>
              <TimeScaleHeader
                hourWidth={hourWidth}
                ref={tsHeader}
                startHour={0}
                endHour={23}
                showHour={6}
              />
            </div>
          </div>
          {/* Data load animation */}
          <div
            className={css(styles.cbLoader)}
            style={{ display: props.showCbLoader ? '' : 'none' }}
          >
            <Loader
              iconType="spinnerWithPulse"
              iconSize="5x"
              text="Loading Case Blocks Data..."
            />
          </div>
          {/* Rows */}
          <div className={css(styles.rows)}>
            {/* Left Rows */}
            <div
              className={css(styles.leftRows)}
              style={{ overflow: 'hidden' }}
            >
              <div
                ref={leftRowsRef}
              >
                {leftRows}
              </div>
            </div>
            {/* Center Rows */}
            <div
              className={css(styles.centerRows)}
              ref={scroller}
              onScroll={handleScroll}
            >
              {centerRows}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps({ caseSchedule }) {
  return { ...caseSchedule };
}

export default connect(mapStateToProps, {
  initiateNewCaseBlock,
  initiateNewCaseSchedule,
  updateCaseBlockData,
  saveCaseBlock,
  loadCaseBlocksData,
  addDirectorBlock,
  getProvidersSchedule,
  resetCaseBlocksState,
  getCaseSchedulesData,
  setCaseBlockCaseInitialData,
  editCaseBlockCaseMarkedForCreation,
  toggleScheduleCaseDrawer,
  toggleCaseBlockDrawer,
  createNewCaseBlock,
  setEditCaseBlockCases,
  editCaseBlock,
  setCaseBlockActiveCaseSchedule,
  toggleCbCaseScheduleDashboard,
  markCaseBlockCaseForDeletion,
  unMarkCaseBlockCaseForDeletion,
  unMarkCaseBlockCaseForCreation,
  resetCaseBlockLinkTimeFlag,
  toggleCbLoader,
  setSelectedCaseBlockDate,
  saveFacilityColors
})(GanttGrid);
